import { Component } from 'react';
import {
    withRouter
} from 'react-router-dom';
import {
    Card,
    Layout,
    Page,
    Button,
    Banner,
    Icon,
    ProgressBar,
    Text,
    Collapsible,
    BlockStack,
    ActionList,
    Popover,
    Spinner,
    Tabs,
    Modal,
    VideoThumbnail,

} from '@shopify/polaris';
import {
    ChevronDownIcon,
    ChevronUpIcon,
    MenuHorizontalIcon,
    XIcon,
    ViewIcon,
    DesktopIcon,
    MobileIcon,
    ArrowRightIcon,
} from "@shopify/polaris-icons";
import './indexv3.scss';
import utils from '../../../utils/utils';
import SkeltonLoading from '../../../components/SkeltonLoading';
import { store } from '../../../redux/store';
//优惠翻窗
// import StarIcon from '../../../assets/StarIcon';

import {
    reqUpdateCustomerClick,
    reqGetCheckScoreData,
    reqReviewTipsClick,
    reqGetSiteSpeedUp,
    reqCheckThemeAppExtension,
    reqAddAdsClickNum,
    reqPageSpeedWebsiteCheck,
    reqPostPageSpeedOnline,
    reqGetCannyPlugInSSO,
    reqGetFeedback,
    reqGetSpeedupData,
    reqDelCache,
    reqGetGuideCoupon,
    reqRefreshPageOnline,
    reqGetPageSpeedOnlineStatus,
    reqCheckWebStatus,
    reqUpdGuideSteps,

} from '../../../api';

// 引入 ECharts 主模块 / 仪表盘
import * as echarts from 'echarts/core';
import { GaugeChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { TooltipComponent } from 'echarts/components';
import { connect } from 'react-redux'
import { saveStartReview, setSaveSwitchData, savePayTip, setSaveGuideSwitchData, setThemeExtensionRes } from '../../../redux/actions/getAppPublicData';
import { setPageData } from '../../../redux/actions/getAppPageData';

//轮播图
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import 'swiper/css'; // 公共引入轮播图样式
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import SwitchAll from '../../../utils/switchState';
import Language from '../../../i18n/Language';
import cloneDeep from 'lodash-es/cloneDeep';
import debounce from 'lodash-es/debounce';
import { PAGESPEED_KEY } from '../../../utils/utils';
import FooterTrustHelp from '../../../components/FooterTrustHelp';
import { showNewMessage } from '@intercom/messenger-js-sdk';
import InstrumentPanel from '../../../components/InstrumentPanel';
import CircularGauge from '../../../components/CircularGauge';
import StarRating from '../../../components/StarRating';
import { cwreport } from '../../../cw_center/cw-report';
import { transportReport } from '../../../cw_center/global';
const t = Language;

let timerArr = [], timerArrPage = [], appArr = [], timePage = [], speedArr = [];

echarts.use([GaugeChart, CanvasRenderer, TooltipComponent]);

class dashboardClass extends Component {
    advApi = 'https://appapi.sealapps.net/api/v1/getDateShow?appId=11'
    state = {
        firstContentStepOne: 0,//同步产品图片状态(同步中2 未同步0 同步完成1)
        firstContentSysncProduct: 0,//同步产品图片数量

        firstContentStepTwo: 0,//优化产品图片状态(同步中2 未同步0 同步完成1)
        firstContentOptimizeAlt: 0,//优化产品图片数量

        firstContentApplyLoading: false,//优化按钮apply加载状态
        firstContentModal: false,//优化弹窗开关
        firstContentProgress: true,//是否显示进度条
        AllaltConditions: ["1"],

        productAlt: "%product_title% - %shopname%",

        tempShowReview: false,

        //Remove/Reactivate App按钮加载状态
        reactivateButtonLoading: false,
        removeButtonLoading: false,

        //删除App引入代码确认框状态
        confirmRemoveAppStatus: false,
        //显示删除按钮功能
        showRemoveButton: false,
        //元标签重复
        initLoading: false,
        removeLoading: false,
        is_duplicate: false,
        is_hasMetaTag: true,
        AppNotificationShow: false,
        premiumStatus: false,

        //传递到评星组件的好评开关
        goodRating: false,

        username: this.props.username, //用户名称
        timePeriod: new Date(), //时间段
        timePeriodString: '',
        // domain: '',
        value: '',

        //操作状态
        opreState: 0,
        loadingPage: true,

        totalIssuesCount: 0,
        EstimatedSavedTime: 0,
        isHasOptimiseLogs: false,
        websiteScore: 0,
        bulkEditAndAutoUpdateLogs: [], // 优化节约批量修改与自动日志
        EstimatedSavingDetails: '',

        //add SpeedScore
        SpeedScore: 0,
        SpeedScoreStatus: true,

        isSendData: true, //控制定时请求

        mySpeedScore: 0,
        myWebsiteScore: 0,
        myWebsiteIssues: 0, //错误数量
        refreshStatus: false,
        // isSuccess: true,
        isPlayAnimation: false,
        isNewUser: false,

        // 功能使用情况
        functionUsage: {
            'isJsonLD': 0,
            'isHtmlSiteMap': 0,
            'isAutoMetaTitleDesc': 0,
            'isAutoImageAlt': 0,
            'isStructuredData': 0,
            'isFixedErrors': 0,
            'isOptimiseAllPage': 0,
        },

        //当前选中
        class1: "Tabs_Dashboard_active-tab__3kw-b",
        CurrentlySelectedDiv: "class1",

        //优化图片文字
        imageButtonText: t("Optimize again"),

        //折扣弹窗
        showDiscountPopup: false,
        discountPopupData: [],

        openReview: false,

        //免费图片额度
        ImageFreeQuota: 150,
        imagesAll: 0,
        imagesUse: 0,
        imagesProportion: 0,
        //product额度
        productAll: 0,
        productUse: 0,
        productProportion: 0,
        level: 1,
        OnPagefreeQuota: 50,

        // 全局设置数据
        dashboardData: this.props.dashboardData,

        current_PageSize: 5, // 表格条数

        // 引导列表
        currentSelected: 1, // 默认选择第一个tab
        journeyList: {
            "SEOChecker": {
                "id": 1,
                "title": "Audit and Fix Your Store's SEO Issue",
                "tag": "Audit and Fix Your Store's SEO Issue",
                "desc": "Identify and fix technical and on-page SEO issues that may affect your search rankings.",
                "btn": "Fix Now",
                "url": "/website-check",
                "status": false,
                "img": "/imgs/ai/SEOChecker.png"
            },
            "SiteSpeedUp": {
                "id": 2,
                "title": "Speed Up Your Store",
                "tag": "Speed Up Your Store",
                "desc": "Compress images and optimize performance to deliver a faster browsing experience and improve SEO score.",
                "btn": "Speed up",
                "url": "/speedOpt/site-speedup",
                "status": false,
                "img": "/imgs/ai/WebsitPageSpeedUp.png"
            },
            "AiBlogPost": {
                "id": 3,
                "title": "Create New Blog to Drive Organic Traffic",
                "tag": "Create New Blog to Drive Organic Traffic",
                "desc": "Generate SEO-optimized blog posts with AI to attract new visitors and grow organic traffic.",
                "btn": "Generate Blog",
                "url": "/content-seo/ai-blog-generator",
                "status": false,
                "img": "/imgs/ai/AiBlogPostImg.png"
            },
            "OptBoostRankings": {
                "id": 4,
                "title": "Optimize Existing Content to Boost Rankings",
                "tag": "Optimize Existing Content to Boost Rankings",
                "desc": "Optimize your product pages, blogs, and collections to improve keyword coverage and boost rankings.",
                "btn": "Optimized Content",
                "url": "/on-page-seo/list",
                "status": false,
                "img": "/imgs/ai/OnpageSeoImg.png"
            },
        },
        storeData: store.getState(), // 远程状态
        isShowQuota: true, // 额度banner状态
        showGuideBlock: true, // 指南展示状态

        pcSpeedScore: 0, // pc速度分数
        mobileSpeedScore: 0, // 移动端速度分数

        imageDetailStatus: false, // 图片预览状态
        isEnableLoading: false,

        points_gift_all: 0,
        points_gift_use: 0,
        points_paid_all: 0,
        points_paid_use: 0,

        adverList: [], // 广告列表
        isShowReviewbanner: false, // 是否展示评价banner
        isBeforeShowBanner: true, // 前端判断
        isStartInx: 0,
        selectStartInx: 5, // 默认五星
        ExploreFeaturesTab: 0, // 探索更多功能标签页

        // 常见问题列表
        // frequentData: [
        //     {
        //         id: 'OnPageSEO',
        //         status: false, // 下拉状态
        //         title: "What is the quickest way to optimize the On-Page SEO?",
        //         desc: "SEOWILL has integrated with ChatGPT, allowing our AI writer to automatically generate content to help you resolve all of your On-Page SEO issues.",
        //         point: "AI writer",
        //     },
        //     {
        //         id: 'RankInGoogle',
        //         status: false, // 下拉状态
        //         title: "How does SEOWILL help me rank in Google?",
        //         desc: "The app continuously monitors and fixes your store to ensure that your SEO setup is compliant with Google's standards, saving you thousands of dollars in developer and SEO consultant fees.",
        //     },
        //     {
        //         id: 'AddCodeSEOant',
        //         status: false, // 下拉状态
        //         title: "Will SEOWILL add code to my store?",
        //         desc: "SEOWILL is designed as a set of independent add-ons that are fully compatible with any store, and will not add any code to your store.",
        //     },
        //     {
        //         id: 'UninstallSEOAnt',
        //         status: false, // 下拉状态
        //         title: "How do I uninstall SEOWILL completely?",
        //         desc: "Uninstalling SEOWILL from your apps list will completely remove all traces of the app from your store.",
        //     },
        //     {
        //         id: 'UnistallApp',
        //         status: false, // 下拉状态
        //         title: "If I uninstall the app, will my SEO still be optimized?",
        //         desc: "If the app is not suitable for your needs, you can uninstall it at any time. However, please note that some SEO optimizations will be deleted once you uninstall the app and your store will not be monitored for SEO fixes in the future.",
        //     },
        // ],
        questionList: {
            OnPageSEO: {
                title: "What is the quickest way to optimize the On-Page SEO?",
                tag: [
                    "SEOWILL has integrated with ChatGPT, allowing our AI writer to automatically generate content to help you resolve all of your On-Page SEO issues."
                ]
            },
            RankInGoogle: {
                title: "How does SEOWILL help me rank in Google?",
                tag: [
                    "The app continuously monitors and fixes your store to ensure that your SEO setup is compliant with Google's standards, saving you thousands of dollars in developer and SEO consultant fees."
                ]
            },
            AddCodeSEOant: {
                title: "Will SEOWILL add code to my store?",
                tag: [
                    "SEOWILL is designed as a set of independent add-ons that are fully compatible with any store, and will not add any code to your store."
                ]
            },
            UninstallSEOAnt: {
                title: "How do I uninstall SEOWILL completely?",
                tag: [
                    "Uninstalling SEOWILL from your apps list will completely remove all traces of the app from your store."
                ]
            },
            UnistallApp: {
                title: "If I uninstall the app, will my SEO still be optimized?",
                tag: [
                    "If the app is not suitable for your needs, you can uninstall it at any time. However, please note that some SEO optimizations will be deleted once you uninstall the app and your store will not be monitored for SEO fixes in the future."
                ]
            }
        },
        isShowAffiliateBanner: true, // AffiliateBanner状态
        isShowFeedback: false,  // 新手引导选项展开状态
        isShowGuideMain: false, // 新手引导展开状态
        isShowGuideBox: false, // 是否存在新手引导
        isShowGuideOld: true, // 是否展示旧新手引导
        isShowFeedbackBox: false, // 是否打开反馈box
        radioValue: '', // 反馈选项 
        feedbackValue: '', // 反馈
        faqUrl: '', // faq文档链接
        // allCount: -1, // 修复总数

        isShowGoogleWarn: false, // 是否打开google加速
        googleState: false, // 是否已经开启
        isShowToGoogle: false, // 是否展示按钮

        switch_data: {}, // 自定义缓存
        isCurrentShow: true, // 是否该次展示
        isShowFeedbackRes: false, // 是否展示反馈发送结果
        uid: 1, // 用户id
        isShowPageflyBanner: false, // 是否展示pagefly banner
        adverShowMore: false, // 广告更多
        isShowAdver: true, // 广告状态
        isCheckLoading: true,   // 刷新loading
        pageFlyState: 1,
        AppAdverList: [],
        adverInfo: this.props.adverInfo, // 广告数据
        adverloading: this.props.adverloading,
        RecheckButtonLoading: false,
        TopUrlContent: '', // 域名
        pendingData: [
            {
                id: 1, num: 0, desc: 'image alt texts need optimization', url: '/on-page-seo/image-alt-text',
            },
            {
                id: 2, num: 0, desc: 'images need optimization', url: '/speedOpt/PageSpeed',
            },
            {
                id: 3, num: 0, desc: 'broken links need fixing', url: '/technicalSEO/broken-link/view-errors',
            },
            {
                id: 4, num: 0, desc: 'pages are pending optimization', url: "/on-page-seo/list",
            },
            {
                id: 5, num: 0, desc: 'exchange requests for external links is pending', url: '/backlinks/exchange-backlink',
            },
        ], // 列表
        pendSvg: {
            "1": <svg width="16" height="8" viewBox="0 0 15 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M3.67798 0.928935C3.5539 0.667 3.29001 0.5 3.00018 0.5C2.71034 0.5 2.44645 0.667 2.32237 0.928935L0.0723726 5.67894C-0.104947 6.05328 0.0547707 6.50048 0.429111 6.6778C0.803452 6.85512 1.25066 6.69541 1.42798 6.32106L1.8169 5.5H4.18345L4.57237 6.32106C4.74969 6.69541 5.1969 6.85512 5.57124 6.6778C5.94558 6.50048 6.1053 6.05328 5.92798 5.67894L3.67798 0.928935ZM3.47292 4L3.00018 3.00198L2.52743 4H3.47292Z" fill="#4A4A4A" />
                <path d="M7.25018 0.75C7.6644 0.75 8.00018 1.08579 8.00018 1.5V5.25H9.50018C9.9144 5.25 10.2502 5.58579 10.2502 6C10.2502 6.41421 9.9144 6.75 9.50018 6.75H7.25018C6.83597 6.75 6.50018 6.41421 6.50018 6V1.5C6.50018 1.08579 6.83597 0.75 7.25018 0.75Z" fill="#4A4A4A" />
                <path d="M10.0002 0.75C9.58597 0.75 9.25018 1.08579 9.25018 1.5C9.25018 1.91421 9.58597 2.25 10.0002 2.25H11.0002V6C11.0002 6.41421 11.336 6.75 11.7502 6.75C12.1644 6.75 12.5002 6.41421 12.5002 6V2.25H13.5002C13.9144 2.25 14.2502 1.91421 14.2502 1.5C14.2502 1.08579 13.9144 0.75 13.5002 0.75H10.0002Z" fill="#4A4A4A" />
            </svg>,
            "2": <svg key={'icon-1'} width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.5 6C10.3284 6 11 5.32843 11 4.5C11 3.67157 10.3284 3 9.5 3C8.67157 3 8 3.67157 8 4.5C8 5.32843 8.67157 6 9.5 6Z" fill="#4A4A4A" />
                <path fillRule="evenodd" clipRule="evenodd" d="M6.0179 0.5H7.98211C8.79494 0.499993 9.45056 0.499987 9.98147 0.543364C10.5281 0.588026 11.0082 0.682385 11.4525 0.908726C12.1581 1.26825 12.7317 1.84193 13.0913 2.54754C13.3176 2.99175 13.412 3.4719 13.4566 4.01853C13.5 4.54944 13.5 5.20505 13.5 6.01788V7.98212C13.5 8.79496 13.5 9.45056 13.4566 9.98147C13.412 10.5281 13.3176 11.0082 13.0913 11.4525C12.7317 12.1581 12.1581 12.7317 11.4525 13.0913C11.0082 13.3176 10.5281 13.412 9.98147 13.4566C9.45056 13.5 8.79495 13.5 7.98212 13.5H6.01788C5.20505 13.5 4.54944 13.5 4.01853 13.4566C3.4719 13.412 2.99175 13.3176 2.54754 13.0913C1.84193 12.7317 1.26825 12.1581 0.908726 11.4525C0.682385 11.0082 0.588026 10.5281 0.543364 9.98147C0.499987 9.45056 0.499993 8.79495 0.5 7.98212V6.0179C0.499993 5.20506 0.499987 4.54944 0.543364 4.01853C0.588026 3.4719 0.682385 2.99175 0.908726 2.54754C1.26825 1.84193 1.84193 1.26825 2.54754 0.908726C2.99175 0.682385 3.4719 0.588026 4.01853 0.543364C4.54944 0.499987 5.20506 0.499993 6.0179 0.5ZM4.14068 2.03838C3.68681 2.07547 3.42604 2.1446 3.22852 2.24524C2.80516 2.46095 2.46095 2.80516 2.24524 3.22852C2.1446 3.42604 2.07547 3.68681 2.03838 4.14068C2.00058 4.60331 2 5.19755 2 6.05V7.4785L2.7228 6.61114C3.38159 5.82059 4.57697 5.76637 5.30462 6.49402L7.99999 9.18939L9.17963 8.00974C9.91716 7.27222 11.132 7.3395 11.7836 8.15396L11.9997 8.42404C12 8.27538 12 8.11768 12 7.95V6.05C12 5.19755 11.9994 4.60331 11.9616 4.14068C11.9245 3.68681 11.8554 3.42604 11.7548 3.22852C11.539 2.80516 11.1948 2.46095 10.7715 2.24524C10.574 2.1446 10.3132 2.07547 9.85932 2.03838C9.39669 2.00058 8.80245 2 7.95 2H6.05C5.19755 2 4.60331 2.00058 4.14068 2.03838ZM2.03838 9.85932C2.03622 9.83282 2.03417 9.80589 2.03225 9.7785C2.04743 9.76317 2.06209 9.74707 2.07615 9.73019L3.87513 7.57141C3.96924 7.45848 4.14001 7.45073 4.24396 7.55468L7.46966 10.7804C7.76255 11.0733 8.23742 11.0733 8.53032 10.7804L10.2403 9.0704C10.3457 8.96504 10.5192 8.97465 10.6123 9.09101L11.8252 10.6071C11.8037 10.6674 11.7803 10.7214 11.7548 10.7715C11.539 11.1948 11.1948 11.539 10.7715 11.7548C10.574 11.8554 10.3132 11.9245 9.85932 11.9616C9.39669 11.9994 8.80245 12 7.95 12H6.05C5.19755 12 4.60331 11.9994 4.14068 11.9616C3.68681 11.9245 3.42604 11.8554 3.22852 11.7548C2.80516 11.539 2.46095 11.1948 2.24524 10.7715C2.1446 10.574 2.07547 10.3132 2.03838 9.85932Z" fill="#4A4A4A" />
            </svg>,
            "3": <svg key={'icon-2'} width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M12.8424 1.17566C11.3794 -0.287312 9.00745 -0.287312 7.54448 1.17566L5.4279 3.29224C3.9598 4.76034 3.96397 7.14187 5.4372 8.60482L5.77639 8.94164C6.07031 9.23351 6.54518 9.23184 6.83705 8.93793C7.12891 8.64401 7.12725 8.16914 6.83333 7.87727L6.49414 7.54045C5.6102 6.66268 5.6077 5.23376 6.48856 4.3529L8.60514 2.23632C9.48232 1.35913 10.9045 1.35913 11.7817 2.23632C12.6605 3.11508 12.6586 4.54041 11.7776 5.41693L10.7256 6.46356C10.432 6.7557 10.4308 7.23057 10.7229 7.52422C11.0151 7.81786 11.4899 7.81907 11.7836 7.52693L12.8356 6.4803C14.3049 5.01844 14.308 2.64127 12.8424 1.17566ZM1.17849 12.8456C2.64295 14.3101 5.01732 14.3101 6.48179 12.8456L8.60311 10.7243C10.0676 9.25986 10.0676 6.88549 8.60311 5.42102L8.2411 5.05901C7.9482 4.76611 7.47333 4.76611 7.18044 5.05901C6.88754 5.3519 6.88754 5.82677 7.18044 6.11967L7.54245 6.48168C8.42113 7.36036 8.42113 8.78498 7.54245 9.66366L5.42113 11.785C4.54245 12.6637 3.11783 12.6637 2.23915 11.785C1.36047 10.9063 1.36047 9.48168 2.23915 8.603L3.30812 7.53403C3.60101 7.24114 3.60101 6.76627 3.30812 6.47337C3.01522 6.18048 2.54035 6.18048 2.24746 6.47337L1.17849 7.54234C-0.285977 9.00681 -0.285977 11.3812 1.17849 12.8456Z" fill="#4A4A4A" />
            </svg>,
            "4": <svg key={'icon-3'} width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M9.32264 10.3833C8.39957 11.0841 7.24835 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 7.24835 11.0841 8.39957 10.3833 9.32264L13.2803 12.2197C13.5732 12.5126 13.5732 12.9874 13.2803 13.2803C12.9874 13.5732 12.5126 13.5732 12.2197 13.2803L9.32264 10.3833ZM10 6C10 8.20914 8.20914 10 6 10C3.79086 10 2 8.20914 2 6C2 3.79086 3.79086 2 6 2C8.20914 2 10 3.79086 10 6Z" fill="#4A4A4A" />
            </svg>,
            "5": <svg key={'icon-4'} width="16" height="16" viewBox="0 0 31 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M23.0769 20.4265V15.8112H18.4615V12.7342H23.0769V8.11885H26.1538V12.7342H30.7692V15.8112H26.1538V20.4265H23.0769ZM13.8462 15.8112H7.69231C5.5641 15.8112 3.74974 15.0609 2.24923 13.5604C0.748719 12.0599 -0.00102459 10.246 1.05086e-06 8.11885C1.05086e-06 5.99065 0.750258 4.17629 2.25077 2.67578C3.75128 1.17526 5.56513 0.42552 7.69231 0.426545H13.8462V3.50347H7.69231C6.41026 3.50347 5.32051 3.95219 4.42308 4.84962C3.52564 5.74706 3.07692 6.8368 3.07692 8.11885C3.07692 9.4009 3.52564 10.4906 4.42308 11.3881C5.32051 12.2855 6.41026 12.7342 7.69231 12.7342H13.8462V15.8112ZM9.23077 9.65731V6.58039H21.5385V9.65731H9.23077ZM30.7692 8.11885H27.6923C27.6923 6.8368 27.2436 5.74706 26.3462 4.84962C25.4487 3.95219 24.359 3.50347 23.0769 3.50347H16.9231V0.426545H23.0769C25.2051 0.426545 27.0195 1.1768 28.52 2.67731C30.0205 4.17783 30.7703 5.99167 30.7692 8.11885Z" fill="#4A4A4A" />
            </svg>,
        },
        isShowQuotaPanel: false,
        websiteFuncList: {
            "SEO analysis": {
                "SEO checker": {
                    state: {},
                    field: "seo_checker",
                    type: "null",
                    url: "/website-check",
                    plan: 1,
                },
                "Google Analytics": {
                    state: {},
                    field: "google_analytics",
                    type: "switch",
                    url: "/keywordRearch/GoogleSearchConsoleV2",
                    plan: 2,
                },
                "Monitor the keywords of your website": {
                    state: {},
                    field: "my_keyword",
                    type: "switch",
                    url: "/keywordRearch/keywords-data",
                    plan: 2,
                },
                "Keyword Search": {
                    state: {},
                    field: "keyword_search",
                    type: "null",
                    url: "/keywordRearch/keywords-search",
                    plan: 1,
                },
                "Competitor Keywords Research": {
                    state: { status: false, quota: 0 },
                    field: "competitor_keywords_research",
                    type: "quota",
                    url: "/keywordRearch/keywords-monitor",
                    plan: 3,
                },
                "Keyword gap with competitors": {
                    state: {},
                    field: "keyword_comparison",
                    type: "switch",
                    url: "/keywordRearch/keywords-gap",
                    plan: 3,
                },
            },
            "Speed Optimization": {
                "Image Optimization": {
                    state: {},
                    field: "image_optimization",
                    type: "quota",
                    url: "/speedOpt/PageSpeed",
                    plan: 1,
                },
                "Site speed up": {
                    state: {},
                    field: "site_speed_up",
                    type: "switch",
                    url: "/speedOpt/site-speedup",
                    plan: 2,
                },
                "AMP": {
                    state: {},
                    field: "amp",
                    type: "switch",
                    url: "/speedOpt/seo-ant-amp",
                    plan: 3,
                },
                // "Instant Page": {
                //     state: {},
                //     field: "instant_page",
                //     type: "switch",
                //     url: "/speedOpt/instant-page",
                //     plan: 1,
                // },
            },
            "Content Optimization": {
                "On-page SEO Scan": {
                    state: {},
                    field: "on_page_seo",
                    type: "quota",
                    url: "/on-page-seo/list",
                    plan: 1,
                },
            },
            "Search Appearance": {
                "Meta Tags": {
                    state: {},
                    field: "meta_tags",
                    type: "switch",
                    url: "/on-page-seo/bulk-edit/manual-bulk-edit",
                    plan: 2,
                },
                "JSON-LD": {
                    state: {},
                    field: "json_ld",
                    type: "switch",
                    url: "/technicalSEO/structured-data",
                    plan: 2,
                },
                "Local Business": {
                    state: {},
                    field: "local_business",
                    type: "switch",
                    url: "/technicalSEO/local-business",
                    plan: 2,
                },
                "Instant Index": {
                    state: {},
                    field: "instant_index",
                    type: "switch",
                    url: "/technicalSEO/instant-index",
                    plan: 2,
                },
            },
            "Link Management": {
                "Broken links": {
                    state: {},
                    field: "broken_links",
                    type: "switch",
                    url: "/technicalSEO/broken-link/view-errors",
                    plan: 1,
                },
                "Backlink Audit": {
                    state: {},
                    field: "backlink_audit",
                    type: "switch",
                    url: "/backlinks/backlink-audit",
                    plan: 3,
                },
                "Exchange Backlink": {
                    state: {},
                    field: "exchange_backlink",
                    type: "quota",
                    url: "/backlinks/exchange-backlink",
                    plan: 1,
                },
                "HTML Sitemap": {
                    state: {},
                    field: "html_sitemap",
                    type: "switch",
                    url: "/technicalSEO/html-sitemap",
                    plan: 1,
                },
            },
        },  // 功能总览
        importantIssues: 0, // seo问题数
        needImprove: 0,
        goodResult: 0,
        scanTime: '',
        exchangeUse: 0, // 额度
        exchangeAll: 0,
        exchangePro: 0,
        onpageUse: 0,
        onpageAll: 0,
        onpagePro: 0,
        imageUse: 0,
        imageAll: 0,
        imagePro: 0,

        isShowNewFunc: false, // 新功能展示状态
        ssoToken: '',
        isShowStatus: false,
        isShowFeedbackAll: false,
        newFuncList: [],  // 新功能列表
        FBLoading: true, // 反馈loading
        isShowFuncNums: false, // 新功能数量
        isShowGetQuota: false, // 显示额度弹窗
        isAnimate: false,
        isAddImageQuota: this.props.isAddImageQuota,
        isShowCompleteTip: true,       // 完成额度获取提示
        openVideo: false,
        isShowPend: false,          // 是否显示待办
        isShowWebSpeed: false,      // 是否显示网站优化
        isShowAionpageBanner: !true, // ai onpage
        isVideoAnimate: false,
        isGetGuideCoupon: false,        // 是否已领取折扣
        isGetGuideEffect: false,        // 是否已应用
        couponLoading: false,

        showTipModalStatus: false,
        themeAppExtensionUrl: "",
        isShowRecheck: false,
        isShowTask: false,              // 任务福利弹层

        passwordStatus: -1, // 密码开启状态
        isResetPageSpeed: false,    // 是否重置页面速度
        trial_days: 0,
        isShowTrualStatus: true,
        isShowTrialDiscount: false,    // 是否显示免费试用横幅

        ExploreFeaturesData: {
            "create": {
                "RowItem": {
                    "AI Blog Generator": {
                        url: "/content-seo/ai-blog-generator",
                        desc: "Create SEO-optimized blog posts in minutes to boost organic traffic.",
                        svg: <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="36" height="36" rx="18" fill="var(--color-primary)" />
                            <path d="M24.8567 24C25.2706 24.0003 25.6065 24.3361 25.6067 24.75C25.6067 25.164 25.2707 25.4997 24.8567 25.5H18.8567C18.4425 25.5 18.1067 25.1642 18.1067 24.75C18.1068 24.3359 18.4426 24 18.8567 24H24.8567ZM21.8655 16.4756L14.3313 24.0107C13.8643 24.4777 13.2671 24.7934 12.6184 24.917L10.6409 25.2939C10.1212 25.3927 9.66515 24.9367 9.76392 24.417L10.1399 22.4395C10.2634 21.7907 10.5792 21.1936 11.0461 20.7266L18.5813 13.1904L21.8655 16.4756ZM24.8577 20.667C25.2717 20.6672 25.6077 21.0029 25.6077 21.417C25.6077 21.8311 25.2717 22.1668 24.8577 22.167H21.3577C20.9435 22.167 20.6077 21.8312 20.6077 21.417C20.6077 21.0028 20.9435 20.667 21.3577 20.667H24.8577ZM20.593 11.1807C21.4999 10.2738 22.9702 10.2739 23.8772 11.1807C24.7839 12.0876 24.784 13.558 23.8772 14.4648L22.6614 15.6797L19.3772 12.3955L20.593 11.1807Z" fill="url(#paint0_linear_2413_23675)" />
                            <defs>
                                <linearGradient id="paint0_linear_2413_23675" x1="17.6794" y1="10.501" x2="17.6794" y2="25.5005" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="white" />
                                    <stop offset="1" stopColor="white" stopOpacity="0.76" />
                                </linearGradient>
                            </defs>
                        </svg>,
                        img: "/imgs/Image/AiBlog.png"
                    },
                },
                "ColumnItem": {
                    "Find Content Idea": {
                        url: "/content-seo/keyword-content-planner",
                        desc: "Don't know what to write? Generate an SEO content strategy in minutes.",
                        svg: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 18C8 20.2091 9.79086 22 12 22C14.2091 22 16 20.2091 16 18M8 18V15.7887C8 15.1349 7.66659 14.5363 7.19153 14.0871C5.84201 12.8111 5 11.0039 5 9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9C19 11.0039 18.158 12.8111 16.8085 14.0871C16.3334 14.5363 16 15.1349 16 15.7887V18M8 18H12H16" stroke="#4A4A4A" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M10 9L12 11M12 11L14 9M12 11V15.5" stroke="#4A4A4A" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    },
                    "Keyword Research": {
                        url: "/keywordRearch/keywords-data",
                        desc: "Discover ranking keywords and competitor insights to guide your content creation.",
                        svg: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.9999 11.9999V8.14282C20.9999 5.30252 18.6974 3 15.8571 3H8.14282C5.30252 3 3 5.30252 3 8.14282V15.8571C3 18.6974 5.30252 20.9999 8.14282 20.9999H11.9999" stroke="#4A4A4A" strokeWidth="1.8" strokeLinecap="round" />
                            <line x1="7.7573" y1="8.52871" x2="14.9572" y2="8.52871" stroke="#4A4A4A" strokeWidth="1.8" strokeLinecap="round" />
                            <line x1="7.7573" y1="13.6713" x2="11.1001" y2="13.6713" stroke="#4A4A4A" strokeWidth="1.8" strokeLinecap="round" />
                            <circle cx="17.1425" cy="17.1423" r="2.95712" stroke="#4A4A4A" strokeWidth="1.8" strokeLinecap="round" />
                            <line x1="19.2728" y1="20" x2="20.5495" y2="21.2767" stroke="#4A4A4A" strokeWidth="1.8" strokeLinecap="round" />
                        </svg>
                    }
                }
            },
            "optimize": {
                "RowItem": {
                    "Site Audit": {
                        url: "/website-check",
                        desc: "Scan your site to identify SEO issues affecting rankings.",
                        svg: <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="36" height="36" rx="18" fill="#2C65FF" />
                            <path d="M23.376 20.1777C25.0666 20.1779 26.4375 21.5486 26.4375 23.2393C26.4375 23.8379 26.2619 24.3945 25.9648 24.8662L26.8018 25.7031C27.0669 25.9688 27.0671 26.3995 26.8018 26.665C26.5361 26.9307 26.1046 26.9307 25.8389 26.665L25.002 25.8281C24.5304 26.1249 23.9743 26.3007 23.376 26.3008C21.6852 26.3008 20.3145 24.93 20.3145 23.2393C20.3145 21.5485 21.6852 20.1777 23.376 20.1777ZM26.1816 19.71C25.4037 19.0677 24.406 18.6817 23.3184 18.6816C20.833 18.6816 18.8184 20.6973 18.8184 23.1826C18.8185 24.2703 19.2042 25.268 19.8467 26.0459H12C10.3432 26.0459 9.00011 24.7027 9 23.0459V16.2275H26.1816V19.71ZM23.1816 10.5C24.8385 10.5 26.1816 11.8431 26.1816 13.5V14.5908H9V13.5C9 11.8431 10.3431 10.5 12 10.5H23.1816ZM12.2734 12.1367C11.8216 12.1367 11.4551 12.5032 11.4551 12.9551C11.4553 13.4068 11.8217 13.7725 12.2734 13.7725C12.725 13.7723 13.0906 13.4067 13.0908 12.9551C13.0908 12.5033 12.7252 12.1369 12.2734 12.1367ZM14.7275 12.1367C14.2759 12.137 13.9102 12.5034 13.9102 12.9551C13.9104 13.4066 14.276 13.7722 14.7275 13.7725C15.1793 13.7725 15.5457 13.4068 15.5459 12.9551C15.5459 12.5032 15.1794 12.1367 14.7275 12.1367Z" fill="url(#paint0_linear_2413_23688)" />
                            <defs>
                                <linearGradient id="paint0_linear_2413_23688" x1="18.0003" y1="10.5" x2="18.0003" y2="26.8643" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="white" />
                                    <stop offset="1" stopColor="white" stopOpacity="0.76" />
                                </linearGradient>
                            </defs>
                        </svg>,
                        img: "/imgs/Image/website-check.png",
                        video: "webCheckVMState",
                        time: 160,
                    },
                },
                "ColumnItem": {
                    "Content Audit & Optimization": {
                        url: "/on-page-seo/list",
                        desc: "Fix on-page SEO issues to improve pages rankings.",
                        svg: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 8.25464C6.26578 8.45067 7.67778 8.77657 9 9.28788M12 6.05337V21C11.7605 21 11.5209 20.9285 11.3168 20.7855C9.19313 19.2974 6.21271 18.623 3.99433 18.3723C2.89642 18.2483 2 17.3311 2 16.2V4.93518C2 3.80402 2.89642 2.88721 3.99433 3.01127C6.21271 3.26195 9.19313 3.93632 11.3168 5.42445C11.725 5.71045 12.275 5.71045 12.6832 5.42445C14.8069 3.93632 17.7873 3.26195 20.0057 3.01127C21.1036 2.88721 22 3.80402 22 4.93518V14M5 12.2546C5.63949 12.3537 6.3163 12.4859 7 12.6584" stroke="#4A4A4A" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M19.5 19.5L21 21M20 17.5C20 18.8807 18.8807 20 17.5 20C16.1193 20 15 18.8807 15 17.5C15 16.1193 16.1193 15 17.5 15C18.8807 15 20 16.1193 20 17.5Z" stroke="#4A4A4A" strokeWidth="1.8" strokeLinecap="round" />
                        </svg>
                    },
                    "Auto-Generated Meta Tags": {
                        url: "/on-page-seo/bulk-edit/manual-bulk-edit",
                        desc: "Auto-generate meta tags to improve click-through rates.",
                        svg: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="2.5" y="2.5" width="19" height="19" rx="4.82536" stroke="#4A4A4A" strokeWidth="1.8" strokeLinecap="round" />
                            <path d="M7.6665 9.23786L7.66671 15M11.5583 9.23786L11.5585 15M11.072 12.1429H7.66671M13.7477 10.052C14.3165 8.77875 16.1367 8.52534 16.5917 10.0528C17.1605 11.962 14.3165 12.598 13.7477 14.5073V14.7143H16.5917" stroke="#4A4A4A" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    },
                    "Auto-Generated Alt Text": {
                        url: "/on-page-seo/image-alt-text",
                        desc: "Auto-generate alt text to improve image search visibility.",
                        svg: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="2.3335" y="3" width="19" height="18" rx="4.5714" stroke="#4A4A4A" strokeWidth="1.8" strokeLinecap="round" />
                            <path d="M6 14.4004L7.9697 9.40039L10.3333 14.4004" stroke="#4A4A4A" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6.3335 13.5H9.3335" stroke="#4A4A4A" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12.833 9.40039V14.4004" stroke="#4A4A4A" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M15.6997 9.40039H16.9662M18.1997 9.40039H16.9662M16.9662 9.40039V14.4004" stroke="#4A4A4A" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    },
                },
            },
            "boost": {
                "RowItem": {
                    "Speed Optimization": {
                        url: "/speedOpt/site-speedup",
                        desc: "Improve page speed to boost rankings and user experience.",
                        svg: <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="36" height="36" rx="18" fill="#FFB800" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M21.6562 25.5H23.85C26.0039 25.5 27.75 23.7371 27.75 21.5625V19.5938C27.75 14.1572 23.3848 9.75 18 9.75C12.6152 9.75 8.25 14.1572 8.25 19.5938V21.5625C8.25 23.7371 9.99609 25.5 12.15 25.5H14.3438C14.3438 23.6078 15.7539 22.0481 17.5711 21.8337L20.2979 17.2453C20.5057 16.8956 20.9549 16.7823 21.3012 16.992C21.6475 17.2018 21.7598 17.6553 21.552 18.005L19.1757 22.0036C20.6182 22.4979 21.6562 23.8765 21.6562 25.5ZM15.8063 25.5C15.8063 24.2822 16.7797 23.294 17.9839 23.2852C17.9943 23.2854 18.0047 23.2854 18.0151 23.2852C19.2197 23.2934 20.1938 24.2819 20.1938 25.5H15.8063ZM13.3173 16.0573C14.2387 14.6198 15.6209 13.4414 18 13.4414C20.3791 13.4414 21.7613 14.6198 22.6827 16.0573C22.9021 16.3997 23.3549 16.4976 23.6939 16.2761C24.033 16.0546 24.13 15.5975 23.9106 15.2552C22.7923 13.5104 20.9955 11.9648 18 11.9648C15.0045 11.9648 13.2077 13.5104 12.0894 15.2552C11.87 15.5975 11.967 16.0546 12.3061 16.2761C12.6451 16.4976 13.0979 16.3997 13.3173 16.0573Z" fill="url(#paint0_linear_2413_23717)" />
                            <defs>
                                <linearGradient id="paint0_linear_2413_23717" x1="18" y1="9.75" x2="18" y2="25.5" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="white" />
                                    <stop offset="1" stopColor="white" stopOpacity="0.76" />
                                </linearGradient>
                            </defs>
                        </svg>,
                        img: "/imgs/Image/speed-up.png",
                        video: "SpeedOptVMState",
                        time: 359,
                    },
                },
                "ColumnItem": {
                    "Image Compression": {
                        url: "/speedOpt/PageSpeed",
                        desc: "Automatically compress images to boost load speed.",
                        svg: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.9999 9.26318C21.9999 9.26318 20.9473 11.1676 20.9473 12.4211C20.9473 13.6745 21.9999 15.579 21.9999 15.579" stroke="#4A4A4A" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M1.99986 9.26318C1.99986 9.26318 3.05249 11.1676 3.05249 12.4211C3.05249 13.6745 1.99986 15.579 1.99986 15.579" stroke="#4A4A4A" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M18.5435 3H6.16472C5.06661 3 4.25504 4.03445 4.48411 5.10841C4.91587 7.13269 5.47989 10.1986 5.47814 12.3947C5.47649 14.4552 4.97577 17.033 4.55761 18.8275C4.30286 19.9208 5.12205 21 6.24459 21H18.4294C19.6427 21 20.4798 19.7463 20.0903 18.5972C19.4633 16.7475 18.7482 14.1608 18.7825 12.0621C18.8157 10.0254 19.5737 7.25792 20.1943 5.319C20.555 4.19224 19.7266 3 18.5435 3Z" stroke="#4A4A4A" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M5.15784 16.9824L8.84921 14.1992C9.44539 13.7497 10.2351 13.6496 10.9245 13.9362L19.5001 17.5" stroke="#4A4A4A" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            <circle cx="15.5" cy="7.5" r="1.5" fill="#4A4A4A" />
                        </svg>
                    },
                    "Google Structured Data": {
                        url: "/technicalSEO/structured-data",
                        desc: "Add JSON-LD schema for better Google & AI visibility",
                        svg: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.9393 11.9966C13.9393 13.0697 13.0694 13.9395 11.9964 13.9395C10.9233 13.9395 10.0535 13.0697 10.0535 11.9966C10.0535 10.9236 10.9233 10.0537 11.9964 10.0537C13.0694 10.0537 13.9393 10.9236 13.9393 11.9966Z" stroke="#4A4A4A" strokeWidth="1.8" />
                            <ellipse cx="12.0347" cy="12.0356" rx="11.188" ry="4.36826" transform="rotate(45 12.0347 12.0356)" stroke="#4A4A4A" strokeWidth="1.8" />
                            <ellipse cx="12.035" cy="12.0342" rx="11.188" ry="4.36826" transform="rotate(135 12.035 12.0342)" stroke="#4A4A4A" strokeWidth="1.8" />
                        </svg>
                    },
                    "Broken Link Redirects": {
                        url: "/technicalSEO/broken-link/view-errors",
                        desc: "Automatically fix 404 errors to protect SEO rankings.",
                        svg: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21 18.0414V10.1272C21 8.90111 20.4604 7.7399 19.5301 6.96435L14.5301 2.79571C13.0577 1.56809 10.9423 1.5681 9.46986 2.79571L4.46986 6.96435C3.53965 7.7399 3 8.90111 3 10.1272V18.0414C3 20.2967 4.79086 22.125 7 22.125H17C19.2091 22.125 21 20.2967 21 18.0414Z" stroke="#4A4A4A" strokeWidth="1.8" strokeLinecap="round" />
                            <path d="M14.8033 12.4399L15.1569 12.0819C15.9379 11.2911 15.9379 10.0089 15.1569 9.21811C14.3758 8.4273 13.1095 8.4273 12.3285 9.21811L10.9142 10.65C10.1332 11.4408 10.1332 12.723 10.9142 13.5138M8.43934 13.1557L8.08579 13.5137C7.30474 14.3045 7.30474 15.5867 8.08579 16.3775C8.86684 17.1683 10.1332 17.1683 10.9142 16.3775L12.3284 14.9456C13.1095 14.1548 13.1095 12.8726 12.3284 12.0818" stroke="#4A4A4A" strokeWidth="1.8" strokeLinecap="round" />
                        </svg>,
                    },
                },

            },
            "aiVisibility": {
                "RowItem": {
                    "llms.txt": {
                        url: "/technicalSEO/llms-txt",
                        desc: "Generate a llms.txt file to help AI Chats understand your store and recommend your products in their answers.",
                        svg: "",
                        img: "/imgs/Image/llms.png"
                    },
                    "Structured Data": {
                        url: "/technicalSEO/structured-data",
                        desc: "Add product, article, FAQ, and organization schema to improve visibility in search results.",
                        svg: "",
                        img: "/imgs/Image/structured.png",
                        video: "StructuredDataVMState",
                        time: 316,
                    },
                },

            },
        },
        performanceTab: 'pc',
        isFinishGuide: false,
        finishGuideObj: '',
        SEOScorePerc: 0,
        userInfo: {},
        brokenLinkVMState: false,
        keywordPlannerVMState: false,
        webCheckVMState: false,
        SpeedOptVMState: false,
        showAmpDownBanner: false,
        StructuredDataVMState: false,
    };

    componentDidMount() {
        const _store = store.getState().public;
        this.checkThemeExtension(false, _store.themeExtensionRes); // 先判断是否开启扩展
        this.getData(this.props.dashboardData); // 首页数据+卡片数据
        this.getRecommandAppList(this.props.adverInfo); // 设置广告数据
        this.getPageSpeedOnlineStatus();        // 获取加速状态
        // this.getFeedbackList();
        // this.checkWebsiteState();
        // 监听试用天数
        this.setTrialDays(store.getState().page.pageInit);
        store.subscribe(() => {
            const _t = store.getState();
            this.setTrialDays(_t.page.pageInit);
            this.handleSetHomeStreamData(_t.public); // 首页数据+卡片数据
        })
        try {
            let showState = sessionStorage.getItem("isShowCompleteTip");
            let showTrualStatus = sessionStorage.getItem("isShowTrualStatus");
            this.setState({
                isShowCompleteTip: !Boolean(showState),
                isShowTrualStatus: !Boolean(showTrualStatus),
                review_score: !Boolean(sessionStorage.getItem('review_score')),
            })
        } catch (e) { }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.dashboardData !== this.props.dashboardData) {
            this.setState({
                dashboardData: nextProps.dashboardData,
            }, () => {
                if (Boolean(nextProps.dashboardData.status)) {
                    this.getData(nextProps.dashboardData);
                }
            })
        }

        if (nextProps.isResetData !== this.props.isResetData) {
            this.setState({
                isResetData: nextProps.isResetData
            }, () => {
                if (Boolean(nextProps.dashboardData.status)) {
                    this.getData(nextProps.dashboardData);
                }
            })
        }

        if (nextProps.adverInfo !== this.props.adverInfo) {
            this.setState({
                adverInfo: nextProps.adverInfo,
            }, () => {
                this.getRecommandAppList(nextProps.adverInfo)
            })
        }
        if (nextProps.adverloading !== this.props.adverloading) {
            this.setState({
                adverloading: nextProps.adverloading,
            })
        }

        if (nextProps.isAddImageQuota !== this.props.isAddImageQuota) {
            this.setState({
                isAddImageQuota: nextProps.isAddImageQuota,
            })
        }

        return true;
    }

    // 设置试用天数
    setTrialDays = (data) => {
        let _data = data || store.getState().page.pageInit;
        let res = data.pricingPlan;
        if (_data) {
            if (res?.ack === 1) {
                let pre_month = res.data.meal_list.month[1].coupon_info?.trial_days || 0;
                let pre_year = res.data.meal_list.year[1].coupon_info?.trial_days || 0;
                let trial_days = res.data.trial_days || pre_month || pre_year || 0;
                this.setState({
                    trial_days,
                    isShowTrialDiscount: trial_days > 0,
                })
            }
        } else {
            setTimeout(() => {
                this.setTrialDays(store.getState().page.pageInit);
            }, 500)
        }
    }

    // 获取 app || banner
    getRecommandAppList = (res) => {
        if (res?.ack === 1) {
            let newBanner = [];
            let _t = res.data.data || [];
            let _rotate_popup = _t.filter(item => item.type === 'rotate_popup');
            let _list = _t.filter(item => item.type === 'list');
            // banner
            if (_rotate_popup && _rotate_popup.length > 0) {
                _rotate_popup.forEach(item => {
                    newBanner.push({
                        id: item.id,
                        title: item.app_name,
                        logo: item.img_url,
                        desc: item.desc,
                        url: item.jump_url,
                        btn: item?.button_text,
                    })
                })
                this.setState({
                    AppAdverList: newBanner
                }, () => {
                    const _store = this.props.public.appSwitch;
                    if (!Boolean(_store?.app_adver)) {
                        this.swiperReAppList();
                        // this.setState({
                        //     isShowPageflyBanner: true,
                        // }, () => {
                        // })
                    } else {
                        this.setState({
                            isShowPageflyBanner: false,
                        })
                    }
                })
            }

            // 应用广告
            if (_list && _list.length > 0) {
                this.formatAdverData(_list); // 格式化广告数据
            }

        }
    }

    // 获取主题扩展状态
    checkThemeExtension = (refresh = false, reduxData = null) => {
        this.setState({
            isCheckLoading: true,
        }, async () => {
            if (refresh) {
                reduxData = null;
            }
            const res = reduxData || (await reqCheckThemeAppExtension());
            if (res.code === 200) {
                store.dispatch(setThemeExtensionRes(res));
                this.setState({
                    themeAppExtensionUrl: res.data.url,
                    showTipModalStatus: !Boolean(res.data?.status),
                    isCheckLoading: false,
                })
            }
        })
    }

    // 获取pagespeed状态
    getPageSpeedStatus = async () => {
        const res = await reqGetSiteSpeedUp();
        if (res) {
            this.setState({
                googleState: !Boolean(res?.status),
            })
        }
    }

    // 图表可视化
    setEChartsData = (data, isReset = false, isOnlySpeed = false) => {
        try {
            if (Boolean(document.getElementById('SEOScore')) && Boolean(document.getElementById('MobileScore')) && Boolean(document.getElementById('PCScore'))) {
                // 基于准备好的dom，初始化echarts实例
                let SEOScoreBox = Boolean(echarts.getInstanceByDom(document.getElementById('SEOScore'))) ? echarts.getInstanceByDom(document.getElementById('SEOScore')) : echarts.init(document.getElementById('SEOScore'));
                let MobileScoreBox = Boolean(echarts.getInstanceByDom(document.getElementById('MobileScore'))) ? echarts.getInstanceByDom(document.getElementById('MobileScore')) : echarts.init(document.getElementById('MobileScore'));
                let PCScoreBox = Boolean(echarts.getInstanceByDom(document.getElementById('PCScore'))) ? echarts.getInstanceByDom(document.getElementById('PCScore')) : echarts.init(document.getElementById('PCScore'));

                // 图表数据
                let scoreInfo = isReset ? data : data.seo_data;
                // 左侧图表 -- 分数/颜色主题
                if (!isOnlySpeed) {
                    let seo_score = scoreInfo.seo_score.number;
                    let left_color = seo_score <= 60 ? '#e61523' : seo_score > 60 && seo_score <= 85 ? '#f3911e' : seo_score > 85 ? '#4fb681' : '#4fb681';
                    this.setLeftSEOScoreCharts(SEOScoreBox, seo_score, left_color);
                }
                // 右侧图表 -- 分数/颜色主题
                // 移动端
                let mobile_score = scoreInfo.speed_score.mobile.number;
                let mobile_color = mobile_score < 40 ? ['#ff3333', '#cc0000', '#ffeaea'] : mobile_score >= 40 && mobile_score < 70 ? ['#ffaa33', '#c33300', '#fff6ea'] : mobile_score >= 70 ? ['#00cc66', '#008800', '#e5faef'] : ['#ff3333', '#cc0000', '#ffeaea'];
                this.setRightGoogleMobileCharts(MobileScoreBox, mobile_score, mobile_color);
                // pc端
                let pc_score = scoreInfo.speed_score.desktop.number;
                let pc_color = pc_score < 50 ? ['#ff3333', '#cc0000', '#ffeaea'] : pc_score >= 50 && pc_score < 85 ? ['#ffaa33', '#c33300', '#fff6ea'] : pc_score >= 85 ? ['#00cc66', '#008800', '#e5faef'] : ['#ff3333', '#cc0000', '#ffeaea'];
                this.setRightGooglePCCharts(PCScoreBox, pc_score, pc_color);

                // 适配屏幕大小 重绘
                window.onresize = () => {
                    // 监听页面变化，改变表格宽度
                    SEOScoreBox.resize()
                    MobileScoreBox.resize()
                    PCScoreBox.resize()
                }
            } else {
                setTimeout(() => {
                    this.setEChartsData(data, isReset, isOnlySpeed);
                }, 100)
            }
        } catch (e) {
            setTimeout(() => {
                this.setEChartsData(data, isReset, isOnlySpeed);
            }, 500)
        }
    }

    // SEO Score 图表
    setLeftSEOScoreCharts = (target, data, colors) => {
        let gaugeData = [
            {
                value: Number((data / 100).toFixed(2)),
                // name: t("SCORE"),
            }
        ];
        // 设置参数
        target.setOption({
            series: [
                {
                    type: 'gauge',
                    radius: '170%',
                    startAngle: 180,
                    endAngle: 0,
                    center: ['50%', '85%'],
                    min: 0,
                    max: 1,
                    splitNumber: 8,
                    axisLine: {
                        lineStyle: {
                            width: 7,
                            color: [
                                [0.60, '#e61523'],
                                [0.85, '#f3911e'],
                                [1, '#4fb681'],
                            ]
                        },
                        roundCap: true,
                    },
                    pointer: {
                        icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
                        length: '15%',
                        width: 10,
                        offsetCenter: [0, '-55%'],
                        itemStyle: {
                            color: 'auto'
                        }
                    },
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: true,
                        length: 10,
                        lineStyle: {
                            color: 'auto',
                            width: 1
                        },
                    },
                    axisLabel: {
                        show: false,
                    },
                    title: {
                        offsetCenter: [0, '10%'],
                        fontSize: 15,
                        fontFamily: 'Inter', // 设置字体样式
                    },
                    detail: {
                        fontSize: 48,
                        fontFamily: 'Inter', // 设置字体样式
                        offsetCenter: [0, '-20%'],
                        valueAnimation: true,
                        color: colors,
                        formatter: function (value) {
                            return Math.round(value * 100) + '';
                        },
                    },
                    data: gaugeData
                }
            ]
        });
    }

    // 谷歌分数图表 移动端
    setRightGoogleMobileCharts = (target, data, colors) => {
        let gaugeData = [
            {
                value: data,
                name: t("Mobile"),
                detail: {
                    valueAnimation: true,
                    offsetCenter: ['0%', '6%']
                },
                title: {
                    offsetCenter: ['0%', '140%']
                },
            }
        ];
        // 设置参数
        target.setOption({
            series: [
                {
                    type: 'gauge',
                    radius: '70%',
                    center: ['50%', '45%'],
                    startAngle: 90,
                    endAngle: -270,
                    color: colors[0],
                    pointer: {
                        show: false
                    },
                    progress: {
                        show: true,
                        overlap: false,
                        roundCap: true,
                        clip: false,
                    },
                    axisLine: {
                        lineStyle: {
                            width: 7,
                            color: [[1, colors[2]]]
                        },
                    },
                    splitLine: {
                        show: false,
                        distance: 0,
                        length: 10
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false,
                        distance: 160
                    },
                    data: gaugeData,
                    title: {
                        fontSize: 14,
                        fontWeight: 450,
                        fontFamily: 'Inter', // 设置字体样式
                    },
                    detail: {
                        fontSize: 30,
                        fontFamily: 'Inter', // 设置字体样式
                        color: colors[1],
                    },
                }
            ]
        });
    }

    // 谷歌分数图表 PC端
    setRightGooglePCCharts = (target, data, colors) => {
        let gaugeData = [
            {
                value: data,
                name: t("Desktop"),
                detail: {
                    valueAnimation: true,
                    offsetCenter: ['0%', '6%']
                },
                title: {
                    offsetCenter: ['0%', '140%']
                },
            }
        ];
        // 设置参数
        target.setOption({
            series: [
                {
                    type: 'gauge',
                    radius: '70%',
                    center: ['50%', '45%'],
                    startAngle: 90,
                    endAngle: -270,
                    color: colors[0],
                    pointer: {
                        show: false
                    },
                    progress: {
                        show: true,
                        overlap: false,
                        roundCap: true,
                        clip: false,
                    },
                    axisLine: {
                        lineStyle: {
                            width: 7,
                            color: [[1, colors[2]]]
                        },
                    },
                    splitLine: {
                        show: false,
                        distance: 0,
                        length: 10
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false,
                        distance: 160
                    },
                    data: gaugeData,
                    title: {
                        fontSize: 14,
                        fontWeight: 450,
                        fontFamily: 'Inter', // 设置字体样式
                    },
                    detail: {
                        fontSize: 30,
                        fontFamily: 'Inter', // 设置字体样式
                        color: colors[1],
                    },
                }
            ]
        });
    }

    // 早中晚
    initData = () => {
        let num = new Date(this.state.timePeriod.getTime()).getHours() //获取当前小时
        if (num > 18) {
            this.timePeriodString = t("Good evening")
        } else if (num > 12) {
            this.timePeriodString = t("Good afternoon")
        } else if (num > 0) {
            this.timePeriodString = t("Good morning")
        }
        this.setState({ timePeriodString: this.timePeriodString });
    }

    // posthog埋点 ======================================================= start
    // 引导状态
    cwreportGuideState = (s_index = 1, c_num = 0) => {
        if (window.shopify && cwreport) {
            transportReport('complete_guide_step', {
                step_index: s_index,
                completed_steps: c_num,
                total_steps: 4,
            });
        }
    }
    // 引导完成
    cwreportGuideComplete = () => {
        if (window.shopify && cwreport) {
            transportReport('complete_quick_guide');
        }
    }
    // 引导步骤埋点：统一上报、按位去重，避免重复上传
    // 步骤可由“点击完成”或“用户自行完成任务”两种方式触发，这里统一收口
    // 状态结构存储在 switch_data.guide_step_report：
    //   { at: 时间戳, st: 已上报位标记, exp: 0 }
    //   st 按位记录已上报的步骤(seo_checker=1, speed_up=2, ai_blog=4, opt_content=8)，bit16 表示已上报“全部完成”
    reportGuideSteps = () => {
        if (!(window.shopify && cwreport)) return;
        const publicInit = store.getState().public.publicInit;
        const guideData = publicInit?.guide_steps;
        if (!Boolean(guideData) || guideData.length === 0) return;

        const REPORT_KEY = 'guide_step_report';
        const ALL_DONE_BIT = 16;
        // 步骤顺序即 step_index，对应去重位标记
        const stepOrder = ['seo_checker', 'speed_up', 'ai_blog', 'opt_content'];
        const stepBits = { seo_checker: 1, speed_up: 2, ai_blog: 4, opt_content: 8 };

        // 已上报的位标记
        const switchData = publicInit?.head_data?.switch_data;
        const reportedMask = (typeof switchData === 'boolean' || !switchData)
            ? 0
            : Number(switchData?.[REPORT_KEY]?.st || 0);

        // 首页步骤及已完成数量
        const homeSteps = guideData.filter(i => i.position === 'home_page');
        const completedCount = homeSteps.filter(i => Boolean(i.is_completed)).length;

        let newMask = reportedMask;
        // 上报“已完成且未上报过”的步骤
        stepOrder.forEach((key, idx) => {
            const step = homeSteps.find(i => i.step_key === key);
            const bit = stepBits[key];
            if (Boolean(step?.is_completed) && (newMask & bit) === 0) {
                this.cwreportGuideState(idx + 1, completedCount);
                newMask |= bit;
            }
        });

        // 全部完成只上报一次
        const allDone = stepOrder.every(key => Boolean(homeSteps.find(i => i.step_key === key)?.is_completed));
        if (allDone && (newMask & ALL_DONE_BIT) === 0) {
            this.cwreportGuideComplete();
            newMask |= ALL_DONE_BIT;
        }

        // 位标记有变化时统一保存状态，下次据此判断去重
        if (newMask !== reportedMask) {
            this.props.requestStateSet(REPORT_KEY, newMask);
        }
    }
    // posthog埋点 ======================================================= end

    // 获取数据
    getData = (dataAll) => {
        let res = dataAll;
        if (Boolean(dataAll.status)) {
            let that = res.publicInit;
            let switchData = res.publicInit.head_data?.switch_data;
            let { journeyList } = this.state;
            // 关于额度
            const _q = that.meal_data;
            // 计算图片进度条
            let imagePro = Number(100 * ((Number(_q.images_use) + Number(_q?.img_usage_use || 0)) / (Number(_q.images_all) + Number(_q?.img_usage_all || 0))));
            // 计算onpage进度条
            let onpagePro = Number(100 * (_q.product_use / _q.product_all));
            // 计算外链互换进度条
            let exchangePro = Number(100 * (_q.backlink_use / _q.backlink_all));
            // 新生引导进度
            let guideData = that?.guide_steps;
            let dashGuideList = [];
            let notFinishList = [];
            let newJourneyList = cloneDeep(journeyList);
            if (Boolean(guideData && guideData?.length > 0)) {
                dashGuideList = guideData.filter(i => i.position === "home_page");
                notFinishList = dashGuideList.filter(i => i.is_completed === 0);
                let nfTag = notFinishList.map(i => i.step_key);
                newJourneyList.SEOChecker.status = nfTag.includes('seo_checker') ? 0 : 1;
                newJourneyList.SiteSpeedUp.status = nfTag.includes('speed_up') ? 0 : 1;
                newJourneyList.AiBlogPost.status = nfTag.includes('ai_blog') ? 0 : 1;
                newJourneyList.OptBoostRankings.status = nfTag.includes('opt_content') ? 0 : 1;
                // 用户自行完成任务后回填的步骤，统一补上埋点（按位去重，不会重复上报）
                this.reportGuideSteps();
            }
            //更新状态
            this.setState({
                level: that.shop_data.level,
                loadingPage: false,
                bulkEditAndAutoUpdateLogs: that.bulkEditAndAutoUpdateLogs,
                AppNotificationShow: (that.appNotification === 1) ? true : false,
                isShowReviewbanner: that.head_data.review_tips,

                isShowGuideBox: Boolean(guideData && guideData.length > 0) ? typeof switchData === 'boolean' ? true : !Boolean(switchData?.dashboard_user_guide) : false,
                isFinishGuide: Boolean(notFinishList.length === 0),
                isShowGuideMain: this.state.isShowGuideMain ? true : Boolean(notFinishList.length > 0),
                // currentSelected: isOldGuide ? 1 : 12,

                isShowPageflyBanner: typeof switchData === 'boolean' ? true : !Boolean(switchData?.dashboard_pagefly),
                isShowAffiliateBanner: typeof switchData === 'boolean' ? true : !Boolean(switchData?.dashboard_affiliate),
                isShowAdver: typeof switchData === 'boolean' ? true : !Boolean(switchData?.dashboard_adver),
                uid: that.shop_data.id,

                TopUrlContent: that.shop_data.domain,
                // pendingData: pData,
                // websiteFuncList: websiteData,
                // 额度
                exchangeUse: Number(_q.backlink_use),
                exchangeAll: Number(_q.backlink_all),
                exchangePro: Number((exchangePro > 100 ? 100 : exchangePro).toFixed(2)),
                onpageUse: Number(_q.product_use),
                onpageAll: Number(_q.product_all),
                onpagePro: Number((onpagePro > 100 ? 100 : onpagePro).toFixed(2)),
                imageUse: Number(_q.images_use) + Number(_q?.img_usage_use || 0),
                imageAll: Number(_q.images_all) + Number(_q?.img_usage_all || 0),
                imagePro: Number((imagePro > 100 ? 100 : imagePro).toFixed(2)),

                // 新功能数量
                isShowFuncNums: typeof switchData === 'boolean' ? true : (!Boolean(switchData?.newFuncNums) || Boolean(Number(switchData?.newFuncNums?.st) !== 2)),

                // 选择模块展示状态
                isShowPend: that.show_model.is_show_task,
                isShowWebSpeed: that.show_model.is_show_web_opt_view,

                // isShowAionpageBanner: typeof switchData === 'boolean' ? true : !Boolean(switchData?.dashboard_ai_onpage),
                isGetGuideCoupon: typeof switchData === 'boolean' ? false : Boolean(switchData?.get_guide_coupon),
                isGetGuideEffect: typeof switchData === 'boolean' ? false : Boolean(switchData?.get_guide_coupon?.st === 1),

                journeyList: newJourneyList,
                userInfo: that.shop_data,
            }, () => {
                //每5秒更新一次页面数据
                // 目前timerArrPage只存储该轮询接口
                if (this.state.isSendData && timerArrPage.length === 0) {
                    this.RefreshPageSpeedOnline();
                }

                if (this.state.isShowPageflyBanner) {
                    this.swiperReAppList();
                }
            });
        } else {
            // this.props.toggleToast(res.msg, true);
            this.setState({
                myWebsiteScore: 0,
            })
        }

        // 清除浏览器链接上的参数
        try {
            var currentUrl = window.location.href;
            if (currentUrl.indexOf("?") !== -1) {
                currentUrl = currentUrl.replace(/(\?|#)[^'"]*/, '');
                if (!!(window.history && window.history.pushState)) {
                    window.history.pushState({}, 0, currentUrl);
                }
            }
        } catch (error) {
            console.warn(error);
        }
    }

    // 首页流式数据
    handleSetHomeStreamData = (data) => {
        const _t = data.homeStreamData;
        const others = _t.other_options;
        const _switch = data.publicInit.head_data?.switch_data;

        // seo分数
        const seo_score = _t.seo_data?.seo_score;
        const speed_score = _t.seo_data?.speed_score;
        if (seo_score) {
            this.setState({
                // myWebsiteIssues: Number(that.seo_data.issues.number), // issue分数
                pcSpeedScore: Number(speed_score.desktop.number),// speed分数 pc
                mobileSpeedScore: Number(speed_score.mobile.number),// speed分数 移动端
                TopState: Number(seo_score.status), // seo_score 和 issue 状态 
                myWebsiteScore: Number(seo_score.number), // seo_score分数
                SEOScorePerc: Number(seo_score.last_top_score) > 0 ? (Number((seo_score.number - seo_score.last_top_score) / seo_score.number) * 100).toFixed(0) : 0,
                SpeedScoreStatus: Number(seo_score.status) ? false : true, // speed状态 
                importantIssues: seo_score.issues.important_issues,   // seo 问题数汇总
                needImprove: seo_score.issues.needs_improvement,
                goodResult: seo_score.issues.good_results,
                scanTime: this.formatUSATime(seo_score.last_scan_time), // 扫描时间
                isSendData: (Number(speed_score.status) && Number(seo_score.status)) ? false : true,
                showAmpDownBanner: Boolean(others?.amp_any_page_enabled && !_switch?.amp_any_page_enabled),
            })

            // 设置图表
            // this.setEChartsData(data); 

        }

        // 判断是否提示支付成功
        if (Boolean(others?.state)) {
            this.payTipToggle(others);
        }

    }

    // 格式化功能总览
    formatWebsiteData = (list, data) => {
        let compare = {
            "Link Management": "backlinks",
            "Content Optimization": "on_page_seo",
            "Search Appearance": "search_appearance",
            "SEO analysis": "seo_analysis",
            "Speed Optimization": "speed_optimization",
        }
        let websiteFuncData = cloneDeep(list);
        Object.keys(data).forEach(item => {
            Object.keys(websiteFuncData).forEach(objs => {
                if (item === 'on_page_seo') {
                    websiteFuncData["Content Optimization"]['On-page SEO Scan'].state = data[item];
                } else {
                    if (item === compare[objs]) {
                        Object.keys(data[item]).forEach(son => {
                            Object.keys(websiteFuncData[objs]).forEach(objSon => {
                                if (son === websiteFuncData[objs][objSon].field) {
                                    websiteFuncData[objs][objSon].state = data[item][son];
                                }
                            })
                        })
                    }
                }
            })
        })

        return websiteFuncData;
    }


    // 格式化时间戳
    formatUSATime = (time) => {
        // 创建一个新的 Date 对象，传入时间戳（秒为单位）
        var date = new Date(time * 1000);

        // 定义月份名称
        var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        // 提取年、月、日、小时、分钟、上午/下午
        var year = date.getFullYear().toString();
        var month = monthNames[date.getMonth()];
        var day = date.getDate();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';

        // 将小时调整为 12 小时制
        hours = hours % 12;
        hours = hours ? hours : 12; // 如果 hours 为 0，则设为 12

        // 格式化分钟数为两位数
        minutes = minutes < 10 ? '0' + minutes : minutes;

        // 组合成指定格式的字符串
        var formattedDate = t(month) + ' ' + (day < 10 ? '0' + day : day) + ', ' + (year.slice(2)) + ' ' + hours + ':' + minutes + ' ' + ampm;
        return formattedDate;
    }

    // 轮播推广app
    swiperReAppList = () => {
        if (appArr.length === 0) {
            let timer = setInterval(() => {
                let { pageFlyState, AppAdverList } = this.state;
                this.setState({
                    pageFlyState: pageFlyState === AppAdverList.length ? 1 : pageFlyState + 1
                })
            }, 5000)
            appArr.push(timer)
        }
    }
    // 清除定时器
    clearAppArray = () => {
        appArr.map(timer => {
            clearInterval(timer);
            appArr.pop();
            return false;
        })
    }

    /**** add 检查站点优化数据 ***/
    RefreshPageSpeedOnline = () => {
        this.setState({ refreshStatus: true }, async () => {
            const res = await reqGetCheckScoreData();
            if (res.ack === 1) {
                timerArrPage.push('RefreshPageSpeedOnline');
                let that = res.data;
                this.props.setHomeStreamRedux({
                    type: 'seo_data',
                    data: that.seo_data,
                }); // 设置更新缓存
                this.setState({
                    TopState: Number(that.seo_data.seo_score.status), // seo_score 和 issue 状态 
                    myWebsiteScore: Number(that.seo_data.seo_score.number), // seo_score分数
                    SpeedScoreStatus: Number(that.seo_data.seo_score.status) ? false : true, // speed状态 
                    pcSpeedScore: Number(that.seo_data.speed_score.desktop.number),// speed分数 pc
                    mobileSpeedScore: Number(that.seo_data.speed_score.mobile.number),// speed分数 移动端
                    myWebsiteIssues: Number(that.seo_data.issues.number), // issue分数
                    isSendData: (Number(that.seo_data.speed_score.status) && Number(that.seo_data.seo_score.status)) ? false : true,
                }, () => {
                    // this.setEChartsData(that.seo_data, true);
                    if (!(Boolean(that.seo_data.speed_score.status) && Boolean(that.seo_data.seo_score.status))) {
                        setTimeout(() => {
                            this.RefreshPageSpeedOnline();
                        }, 5000)
                    } else {
                        this.setState({ refreshStatus: false })
                    }
                })
            } else {
                this.props.toggleToast(res.msg, true);
            }
        })
    };

    // 格式化广告数据
    formatAdverData = (data) => {
        let listAll = [];
        let newList = [];
        let appList = cloneDeep(data);
        let lens = 4;
        if (newList.length <= 0) {
            if (appList.length > 0) {
                for (let i = 0; i < Math.ceil(appList.length / lens); i++) {
                    listAll.push({
                        list: []
                    })
                }
                for (let i = 1; i < Math.ceil((listAll.length * lens) / data.length); i++) {
                    appList = [...appList, ...data];
                }
                listAll.forEach((item, index) => {
                    item['list'] = appList.filter((list, inx) => inx < (index + 1) * lens && inx >= (index) * lens);
                })
            } else {
                listAll = [];
            }
        } else {
            if (appList.length > 0) {
                // 判断banner和app数量大小
                if (newList.length < appList.length / lens) {
                    // banner大于app
                    for (let i = 1; i < data.length / lens; i++) {
                        newList = [...newList, ...JSON.parse(JSON.stringify([].slice(0, Math.ceil(data.length / lens) - newList.length)))];
                        appList = [...appList, ...data];
                    }
                } else if (newList.length > appList.length / lens) {
                    // 循环复制app列表次数
                    for (let i = 1; i < Math.ceil((newList.length * lens) / data.length); i++) {
                        appList = [...appList, ...data];
                    }
                }
                newList.forEach((item, index) => {
                    item['list'] = appList.filter((list, inx) => inx < (index + 1) * lens && inx >= (index) * lens);
                })
                listAll = newList;
            } else {
                listAll = newList;
            }
        }
        this.setState({
            adverList: listAll
        })
    }

    // 支付提示弹窗
    payTipToggle = debounce((data) => {
        // 等语言出来
        let _store = store.getState().public;
        if (_store.Language !== '') {
            // 判断是否支付回调地址
            if (data?.paid_confirm === 1 && _store.payTipStatus === 0) {
                setTimeout(() => {
                    this.props.toggleToast(t("Payment successful"), false);
                    this.props.changePayTipStatus(1);
                    this.delApiCache();
                }, 500)
            }
        } else {
            setTimeout(() => {
                this.payTipToggle(data);
            }, 500)
        }
    }, 500)

    // 清除当前店铺的支付成功提示，身份由服务端鉴权确定。
    delApiCache = async () => {
        const res = await reqDelCache();
        if (res.ack === 1) {
            // 更新公共数据
            this.props.setPayTipState(0);
        }
    }

    // 下拉常见问题列表
    handleColStatus = (val) => {
        let list = cloneDeep(this.state.frequentData);
        list.forEach(item => {
            if (item.title === val.title) {
                item.status = !val.status;
            }
        })

        this.setState({
            frequentData: list,
        })
    }

    //点击联系客服
    handleContactService = async (content) => {
        // window.$crisp.push(["do", "chat:open"])
        try {
            if (content === "Contact Us") {
                // window.$crisp.push(["set", "message:text", ['Hi, could you please help me with the problem of "Duplicate Meta Title & Description"?']])
                showNewMessage('Hi, could you please help me with the problem of "Duplicate Meta Title & Description"?')
            } else if (content === "Submit Sitemap") {
                // window.$crisp.push(["set", "message:text", ["I need help to submit Sitemap"]])
                showNewMessage('I need help to submit Sitemap')
            } else if (content === "Clear Code") {
                // window.$crisp.push(["set", "message:text", ["I need help to clear the code left"]])
                showNewMessage('I need help to clear the code left')
            } else if (content === "Issues Fixing") {
                // window.$crisp.push(["set", "message:text", ["I need help to fix SEO APP conflict issues"]])
                showNewMessage('I need help to fix SEO APP conflict issues')
            } else if (content === "SEO Suggestions") {
                // window.$crisp.push(["set", "message:text", ["I need some SEO suggestions for website"]])
                showNewMessage('I need some SEO suggestions for website')
            } else if (content === "Feature") {
                // window.$crisp.push(["set", "message:text", ["I am wondering if the app has this feature or in the future"]])
                showNewMessage('I am wondering if the app has this feature or in the future')
            } else if (content === "on-page products") {
                // window.$crisp.push(["set", "message:text", ['Hi,Can you increase the "on-page products" quota for me?']])
                showNewMessage('Hi,Can you increase the "on-page products" quota for me?')
            } else if (content === "image compression") {
                // window.$crisp.push(["set", "message:text", ['Hi,Can you increase the "image compression" quota for me?']])
                showNewMessage('Hi,Can you increase the "image compression" quota for me?')
            } else if (content === "image on-page compression") {
                // window.$crisp.push(["set", "message:text", ['Hi,Can you increase the "image compression" quota for me?']])
                showNewMessage('Hi,Can you increase the "image compression" and “On-Page SEO Product” quota for me?')
            } else {
                showNewMessage();
            }
            const params = {
                'path': window.location.pathname,
                'content': content
            };
            await reqUpdateCustomerClick(params);
        } catch (e) {
            this.props.toggleToast(t("Try again later"), true);
        }
    }

    // 帮助模块
    handleHelpBlock = (type) => {
        if (type === 'tutorial_video') {
            this.setState({
                openVideo: true
            })
        } else if (type === 'chat_support') {
            this.handleContactService();
        } else if (type === 'help_center') {
            window.open("https://www.seoant.com/blog/all");
        } else if (type === 'feature') {
            utils.routeJump(this, '/dashboard/Feedback')
        } else if (type === 'clear_code') {
            this.handleContactService("Clear Code");
        } else if (type === 'feature_request') {
            utils.routeJump(this, '/dashboard/Feedback')
        } else { }
    }

    // 跳转外部链接
    jumpTargetUrl = (id, url, name) => {
        window.open(url);
        this.addClickNums(id);

        // posthog 埋点
        this.props.cwreportRecommendAppClick("home_recommended_apps", id, name);
    }



    // 跳转推荐app详情页
    jumpAppRecommand = () => {
        utils.routeJump(this, "/dashboard/integration");
    }

    // 关闭新手引导
    handleDismiss = (type) => {
        this.setState({
            isShowGuideBox: false,
        }, async () => {
            this.props.requestStateSet(type);
        })
    }

    // 打开/关闭反馈
    openGiveFeedbackBox = () => {
        this.setState({
            isShowFeedbackBox: !this.state.isShowFeedbackBox,
            isShowFeedback: false,
        }, () => {
            // 如果是取消
            if (!this.state.isShowFeedbackBox) {
                this.setState({
                    radioValue: '',
                    feedbackValue: '',
                })
            }
        })
    }

    // 关闭完成反馈box
    closeFinishFeedback = () => {
        this.setState({
            isShowFeedbackRes: false,
            isShowFeedbackBox: false,
            radioValue: '',
            feedbackValue: '',
        })
    }

    // 打开新手引导选项
    changeGuideSet = () => {
        this.setState({
            isShowFeedback: !this.state.isShowFeedback,
        })
    }

    // 展开伸缩新手引导
    handleGuideMain = () => {
        this.setState({
            isShowGuideMain: !this.state.isShowGuideMain,
        })
    }

    // 单选
    handleRadioChange = (_, v) => {
        this.setState({
            radioValue: v,
        })
    }

    // 输入反馈
    handleFeedbackChange = (e) => {
        this.setState({
            feedbackValue: e,
        })
    }

    // 打开新手引导对应内容
    openGuideItem = (id) => {
        this.setState({
            currentSelected: id
        })
    }

    // 改变完成状态
    changeFinishState = (e, tag, data) => {
        e && e.stopPropagation();
        // 判断是否已完成
        let { finishGuideObj } = this.state;
        if (Boolean(data.status) || Boolean(finishGuideObj)) {
            return;
        }
        this.setState({
            finishGuideObj: tag,
        }, async () => {
            // 更新状态
            const compareTag = {
                "SEOChecker": "seo_checker",
                "SiteSpeedUp": "speed_up",
                "AiBlogPost": "ai_blog",
                "OptBoostRankings": "opt_content",
            }
            const params = {
                step_key: compareTag[tag],
                position: "home_page",
            }
            const res = await reqUpdGuideSteps(params);
            if (res.ack === 1) {
                // 更新状态
                let newJourneyList = cloneDeep(this.state.journeyList);
                newJourneyList[tag].status = 1;
                // let allFinishState = newJourneyList.every(i => i.status === 1);
                this.setState({
                    journeyList: newJourneyList,
                    // isShowGuideMain: !allFinishState,
                }, () => {
                    let data = cloneDeep(store.getState().public.publicInit.guide_steps);
                    if (data && data?.length > 0) {
                        let compareTag = {
                            "SEOChecker": "seo_checker",
                            "SiteSpeedUp": "speed_up",
                            "AiBlogPost": "ai_blog",
                            "OptBoostRankings": "opt_content",
                        }
                        data.find(i => i.step_key === compareTag[tag]).is_completed = 1;
                        store.dispatch(setSaveGuideSwitchData(data));

                        // posthog埋点：统一上报并按位去重，避免重复
                        this.reportGuideSteps();
                    }
                })
            } else {
                this.props.toggleToast(t("Try again later"), true);
            }

            this.setState({
                finishGuideObj: '',
            })
        })
    }

    // 跳转对应页面
    jumpToPage = (url, type = 'inner') => {
        let { isGetGuideCoupon } = this.state;
        if (url !== '') {
            if (type === 'out') {
                window.open(url)
            } else if (type === 'tip' && isGetGuideCoupon) {
                let isShowFloatingInfo = url.includes('/content-seo/ai-blog-generator');
                utils.routeJump(this, url, null, { isShowFloatingInfo });
            } else {
                utils.routeJump(this, url);
            }
        } else {
            this.props.toggleToast("Link doesn't exist", true);
        }
    }

    // 评价
    setReview = (n) => {
        this.setState({
            isShowReviewbanner: false,
            isBeforeShowBanner: false,
            isCurrentShow: false,
        }, async () => {
            try {
                sessionStorage.setItem('review_score', "close");
            } catch (e) { }
            this.handleDismiss(SwitchAll['0']);
            this.props.setStartReview(false);
            if (window?.ratingOpera) {
                window.ratingOpera.ratingChanged(n, '', true)
            }
            const params = { score: n }
            await reqReviewTipsClick(params);
        })
    }

    handleRateSet = (n) => {
        this.setReview(n);
    }

    // 进入
    mouseEnterReview = (n) => {
        this.setState({
            isStartInx: n,
        })
    }

    // 离开
    mouseLeaveReview = () => {
        this.setState({
            isStartInx: 0
        })
    }

    // 关闭状态 公共
    closePublicState = (type = '') => {
        this.setState({
            isShowToGoogle: true,
        }, () => {
            if (type) {
                this.props.requestStateSet(type)
            }
        })
    }

    // 发送反馈
    sendFeedbackData = () => {
        this.setState({
            isShowFeedbackRes: true,
        }, async () => {
            const params = {
                title: this.state.radioValue === 'useful' ? "This is useful" : "This isn't useful",
                description: this.state.feedbackValue
            }
            await reqReviewTipsClick(params);
        })
    }

    // 关闭pagefly banner
    closePageflyBanner = () => {
        this.setState({
            isShowPageflyBanner: false,
            isCurrentShow: false,
        }, () => {
            this.props.requestStateSet(SwitchAll['1'])
        })
    }

    // 关闭广告
    closeAdverBox = () => {
        this.setState({
            isShowAdver: false,
        }, () => {
            this.props.requestStateSet(SwitchAll['3'])
        })
    }

    // 关闭推广banner
    closeAffiliteBanner = () => {
        this.setState({
            isShowAffiliateBanner: false,
        }, () => {
            this.props.requestStateSet(SwitchAll['2'])
        })
    }

    // 跳转外链
    jumpOutUrl = (item) => {
        window.open(item.url);
        this.addClickNums(item.id);
    }

    // 埋点
    addClickNums = async (id) => {
        const params = {
            ad_id: id,
            click_num: 1,
        }
        const res = await reqAddAdsClickNum(params);
        if (res) { }
    }

    // 重新检测谷歌分数
    handleBackRecheck = () => {
        this.setState({
            RecheckButtonLoading: true,
        }, async () => {
            const res = await reqRefreshPageOnline();
            if (res?.ack === 1) {
                this.getPageSpeedOnlineStatus();
            } else {
                this.props.toggleToast(res.msg, true);
            }
        })
    }
    // 获取状态
    getPageSpeedOnlineStatus = async () => {
        const res = await reqGetPageSpeedOnlineStatus();
        if (res.ack === 1) {
            // 判断是否轮询
            if (res.data?.status !== 1) {
                this.setState({
                    RecheckButtonLoading: true,
                    isResetPageSpeed: true,
                }, () => {
                    if (speedArr.length === 0) {
                        let timer = setInterval(() => {
                            this.getPageSpeedOnlineStatus();
                        }, 10000)
                        speedArr.push(timer);
                    }
                })
            } else {
                this.setState({
                    RecheckButtonLoading: false,
                }, () => {
                    this.clearSpeedArray();
                    // 请求home数据
                    if (this.state.isResetPageSpeed) {
                        this.props.callbackGetHome();
                    }
                })
            }
        } else {
            this.props.toggleToast(res.msg, true);
        }
    }

    // 谷歌api请求
    handleRecheckButton = () => {
        this.setState({
            RecheckButtonLoading: true,
        }, async () => {
            const url = "https://" + this.state.TopUrlContent;
            const deskParam = {
                url: url,
                key: PAGESPEED_KEY,
                strategy: "desktop",
                origin: true,
            };
            const deskRes = await reqPageSpeedWebsiteCheck(deskParam)
            if (deskRes?.error) {
                this.props.toggleToast(t("Try again later"), true);
                this.setState({
                    RecheckButtonLoading: true,
                })
            } else {
                this.setState({
                    // TopTotalNumber:70
                })
            }
            const mobileParm = {
                url: url,
                key: PAGESPEED_KEY,
                strategy: "mobile",
                origin: true,
            };
            const mobileRes = await reqPageSpeedWebsiteCheck(mobileParm)
            if (mobileRes?.error) {
                this.props.toggleToast(t("Try again later"), true);
                this.setState({
                    RecheckButtonLoading: true,
                })
            } else {
                this.setState({
                    isDone: true,
                    // TopState:false,
                    TopTotalNumber: 100,
                }, () => {
                    // this.GetPageSpeedOnlineData();
                })
            }
            const deskPageSpeedData = deskRes.lighthouseResult.audits;
            const mobilePageSpeedData = mobileRes.lighthouseResult.audits;
            this.PostPageSpeedOnline(deskPageSpeedData, mobilePageSpeedData);
        });
    }

    //把数据存到后端
    PostPageSpeedOnline = async (deskPageSpeedData, mobilePageSpeedData) => {
        //过滤数据
        let params = {
            "pcAudits": {
                "first-contentful-paint": {
                    "displayValue": deskPageSpeedData['first-contentful-paint'].displayValue,
                    "score": deskPageSpeedData['first-contentful-paint'].score
                },
                "interactive": {
                    "displayValue": deskPageSpeedData['interactive'].displayValue,
                    "score": deskPageSpeedData['interactive'].score,
                },
                "speed-index": {
                    "displayValue": deskPageSpeedData['speed-index'].displayValue,
                    "score": deskPageSpeedData['speed-index'].score,
                },
                "total-blocking-time": {
                    "displayValue": deskPageSpeedData['total-blocking-time'].displayValue,
                    "score": deskPageSpeedData['total-blocking-time'].score,
                },
                "largest-contentful-paint": {
                    "displayValue": deskPageSpeedData['largest-contentful-paint'].displayValue,
                    "score": deskPageSpeedData['largest-contentful-paint'].score,
                },
                "cumulative-layout-shift": {
                    "displayValue": deskPageSpeedData['cumulative-layout-shift'].displayValue,
                    "score": deskPageSpeedData['cumulative-layout-shift'].score,
                },
                "final-screenshot": {
                    "details": {
                        "data": deskPageSpeedData['final-screenshot'].details.data
                    }
                },
                "unused-javascript": {
                    "numericValue": deskPageSpeedData['unused-javascript'].numericValue,
                    "score": deskPageSpeedData['unused-javascript'].score,
                },
                "uses-text-compression": {
                    "numericValue": deskPageSpeedData['uses-text-compression'].numericValue,
                    "score": deskPageSpeedData['uses-text-compression'].score,
                },
                "unused-css-rules": {
                    "numericValue": deskPageSpeedData['unused-css-rules'].numericValue,
                    "score": deskPageSpeedData['unused-css-rules'].score,
                },
                "server-response-time": {
                    "numericValue": deskPageSpeedData['server-response-time'].numericValue,
                    "score": deskPageSpeedData['server-response-time'].score,
                },
                "render-blocking-resources": {
                    "numericValue": deskPageSpeedData['render-blocking-resources'].numericValue,
                    "score": deskPageSpeedData['render-blocking-resources'].score,
                },
                "unminified-javascript": {
                    "numericValue": deskPageSpeedData['unminified-javascript'].numericValue,
                    "score": deskPageSpeedData['unminified-javascript'].score,
                },
                "legacy-javascript": {
                    "numericValue": deskPageSpeedData['legacy-javascript'].numericValue,
                    "score": deskPageSpeedData['legacy-javascript'].score,
                }
            },
            "mobileAudits": {
                "first-contentful-paint": {
                    "displayValue": mobilePageSpeedData['first-contentful-paint'].displayValue,
                    "score": mobilePageSpeedData['first-contentful-paint'].score
                },
                "interactive": {
                    "displayValue": mobilePageSpeedData['interactive'].displayValue,
                    "score": mobilePageSpeedData['interactive'].score,
                },
                "speed-index": {
                    "displayValue": mobilePageSpeedData['speed-index'].displayValue,
                    "score": mobilePageSpeedData['speed-index'].score,
                },
                "total-blocking-time": {
                    "displayValue": mobilePageSpeedData['total-blocking-time'].displayValue,
                    "score": mobilePageSpeedData['total-blocking-time'].score,
                },
                "largest-contentful-paint": {
                    "displayValue": mobilePageSpeedData['largest-contentful-paint'].displayValue,
                    "score": mobilePageSpeedData['largest-contentful-paint'].score,
                },
                "cumulative-layout-shift": {
                    "displayValue": mobilePageSpeedData['cumulative-layout-shift'].displayValue,
                    "score": mobilePageSpeedData['cumulative-layout-shift'].score,
                },
                "final-screenshot": {
                    "details": {
                        "data": mobilePageSpeedData['final-screenshot'].details.data
                    }
                },
                "unused-javascript": {
                    "numericValue": mobilePageSpeedData['unused-javascript'].numericValue,
                    "score": mobilePageSpeedData['unused-javascript'].score,
                },
                "uses-text-compression": {
                    "numericValue": mobilePageSpeedData['uses-text-compression'].numericValue,
                    "score": mobilePageSpeedData['uses-text-compression'].score,
                },
                "unused-css-rules": {
                    "numericValue": mobilePageSpeedData['unused-css-rules'].numericValue,
                    "score": mobilePageSpeedData['unused-css-rules'].score,
                },
                "server-response-time": {
                    "numericValue": mobilePageSpeedData['server-response-time'].numericValue,
                    "score": mobilePageSpeedData['server-response-time'].score,
                },
                "render-blocking-resources": {
                    "numericValue": mobilePageSpeedData['render-blocking-resources'].numericValue,
                    "score": mobilePageSpeedData['render-blocking-resources'].score,
                },
                "unminified-javascript": {
                    "numericValue": mobilePageSpeedData['unminified-javascript'].numericValue,
                    "score": mobilePageSpeedData['unminified-javascript'].score,
                },
                "legacy-javascript": {
                    "numericValue": mobilePageSpeedData['legacy-javascript'].numericValue,
                    "score": mobilePageSpeedData['legacy-javascript'].score,
                }
            }
        };
        let response = await reqPostPageSpeedOnline(params);
        if (response.code === 200) {
            this.GetPageSpeedOnlineData();
            return true;
        }
    }

    //获取数据库数据
    GetPageSpeedOnlineData = async () => {
        this.setState({ polling: true })
        const res = await reqGetSpeedupData();
        this.props.getPageDataRedux({ 'getPageSpeedOnline': res });
        if (res.ack === 1) {
            if (res.data.reports.status === 1) {
                this.setState({
                    RecheckButtonLoading: false,
                }, () => {
                    this.props.toggleToast(t("Success"));
                    if (Boolean(res.data.speed_switch) && res.data.reports.after_opt.m_score === 0 && res.data.reports.after_opt.pc_score === 0) {
                        if (timePage.length === 0) {
                            this.handleRecheckButton();
                            let timer = setInterval(() => {
                                this.GetPageSpeedOnlineData();
                            }, 3000)
                            timePage.push(timer)
                        }
                    } else {
                        this.setState({
                            polling: false,
                        }, () => {
                            // 清除定时器
                            this.clearTimerArray();
                        })
                    }
                    // let _data = res.data.reports.end_opt;
                    // let newScore = {
                    //     speed_score: {
                    //         mobile: {
                    //             number: _data.m_score,
                    //         },
                    //         desktop: {
                    //             number: _data.pc_score,
                    //         }
                    //     }
                    // }
                    // this.setEChartsData(newScore, true, true);
                })
            } else {
                if (timePage.length === 0) {
                    this.handleRecheckButton();
                    let timer = setInterval(() => {
                        this.GetPageSpeedOnlineData();
                    }, 3000)
                    timePage.push(timer)
                }
            }
        } else {
            this.setState({
                isShowErrorBanner: res.msg,
            })
        }
    }

    // 清除定时器
    clearTimerArray = () => {
        timePage.map(timer => {
            clearInterval(timer);
            timePage.pop();
            return false;
        })
    }
    clearSpeedArray = () => {
        speedArr.map(timer => {
            clearInterval(timer);
            speedArr.pop();
            return false;
        })
    }

    //点击联系客服
    handleContactSer = () => {
        try {
            showNewMessage();
        } catch (e) {
            this.props.toggleToast(t("Try again later"), true);
        }
    }

    // 跳转
    jumpPageUrl = (url) => {
        if (url === 'pending') {
            // 定位待办
            // PendingBox
            this.setState({
                isShowNewFunc: false,
            }, () => {
                let objs = document.getElementById('PendingBox');
                if (objs) {
                    if (objs?.getBoundingClientRect) {
                        window.scrollTo(0, objs.getBoundingClientRect().top - 100, "smooth");
                    }
                    setTimeout(() => {
                        this.setState({
                            isAnimate: true
                        }, () => {
                            setTimeout(() => {
                                this.setState({
                                    isAnimate: false
                                })
                            }, 1000)
                        })
                    }, 200)
                }
            })
        } else if (url === "NewSEOAntUserGuide") {
            // 打开教学视频
            this.setState({
                isShowNewFunc: false,
            }, () => {
                let objs = document.getElementById('NeedHelpBox');
                if (objs) {
                    if (objs?.getBoundingClientRect) {
                        window.scrollTo(0, objs.getBoundingClientRect().top - 100, "smooth");
                    }
                    setTimeout(() => {
                        this.setState({
                            isVideoAnimate: true
                        }, () => {
                            setTimeout(() => {
                                this.handleHelpBlock('tutorial_video');
                                this.setState({
                                    isVideoAnimate: false
                                })
                            }, 1000)
                        })
                    }, 200)
                }
            })
        } else {
            utils.routeJump(this, url);
        }
    }

    // 更改数据模块伸缩 
    changeQuotaViewState = () => {
        this.setState({
            isShowQuotaPanel: !this.state.isShowQuotaPanel
        })
    }

    // 获取ssoToken
    getCannyPlugInSSO = async () => {
        // try {
        const res = await reqGetCannyPlugInSSO();
        if (res.code === 200) {
            this.setState({
                ssoToken: res.data.ssoToken,
            })
        } else {
            this.setState({
                ssoToken: '',
            }, () => {
                this.props.toggleToast(res.msg, true);
            })
        }
        // } catch (error) {
        // this.props.toggleToast('ssoToken error', true);
        // }
    }

    // 发送反馈
    sendBackStatus = () => {
        this.setState({
            isShowStatus: true
        })
    }

    // 是否全展示feedback
    toggleFeedback = () => {
        this.setState({
            isShowFeedbackAll: !this.state.isShowFeedbackAll,
        })
    }

    // 获取feedback列表
    getFeedbackList = async () => {
        const res = await reqGetFeedback();
        if (res.ack === 1) {
            let richText = res.data.new_functions;
            let parser = new DOMParser();
            let doc = parser.parseFromString(richText, 'text/html');
            let nodeList = doc.body.childNodes;
            let newFuncList = [];
            for (let i = 0; i < nodeList.length; i++) {
                let node = nodeList[i];
                if (node.nodeType === Node.ELEMENT_NODE) {
                    let son = node.childNodes[0];
                    newFuncList[i] = {
                        id: i + 1,
                        title: son.innerText || '',
                        url: son.pathname || '/dashboard',
                        desc: son.title ? son.title.split('==')[0] : '',
                        date: son.title ? son.title.split('==')[1] : '',
                    }
                } else {
                    newFuncList[i] = false;
                }
            }
            this.setState({
                FBLoading: false,
                newFuncList: newFuncList.filter(i => Boolean(i)),
            })
        } else {
            this.props.toggleToast(res.msg, true);
        }
    }

    // 打开弹窗
    openNewFuncsModal = () => {
        if (this.state.isShowFuncNums) {
            this.props.requestStateSet(SwitchAll['4'], 2);
        }
        this.setState({
            isShowNewFunc: !this.state.isShowNewFunc,
            isShowFuncNums: false,
        })
    }

    // 打开任务列表
    openTaskPop = () => {
        this.setState({
            isShowTask: !this.state.isShowTask,
        })
    }

    // 打开任务平台
    toggleTaskModal = (type, _state) => {
        this.setState({
            isShowTask: false,
        }, () => {
            this.props.toggleTaskType(type, Boolean(_state));
        })
    }

    // 关闭完成额度
    closeCompleteTip = () => {
        this.setState({
            isShowCompleteTip: false,
        }, () => {
            try {
                sessionStorage.setItem("isShowCompleteTip", "close")
            } catch (e) { }
        })
    }

    // 关闭额度弹窗
    closeImgGetQuota = () => {
        this.setState({
            isShowGetQuota: false,
        }, () => {
            this.props.requestStateSet(SwitchAll['5']);
        })
    }

    // 跳转app
    goSolutionExpert = () => {
        utils.routeJump(this, "/settings", null, { selected: "Solutionexpert", tabkey: 5 });
    }

    // 关闭
    closeAiOnpageBanner = () => {
        this.setState({
            isShowAionpageBanner: false,
        }, () => {
            this.props.requestStateSet('dashboard_ai_onpage');
        })
    }

    // 跳转onpage -> 生成博客页
    jumpOnpageBlogAi = () => {
        utils.routeJump(this, "/on-page-seo/list", null, { obj: 'generate-blog' });
    }

    // 获取折扣
    getGuideCouponInfo = () => {
        this.setState({
            couponLoading: true,
        }, async () => {
            const res = await reqGetGuideCoupon();
            if (res.ack === 1) {
                // this.props.toggleToast(res.msg);
                utils.routeJump(this, "/plan");
                // 更新新手引导状态
                let data = cloneDeep(store.getState().public.publicInit.head_data?.switch_data || []);
                if (data?.get_guide_coupon && data?.get_guide_coupon?.st !== 1) {
                    data.get_guide_coupon = { "at": Math.floor(new Date().getTime() / 1000), "st": 1 };
                    store.dispatch(setSaveSwitchData(data));
                }
            } else {
                this.props.toggleToast(t("Try again later"), true);
            }

            if (res) {
                this.setState({
                    couponLoading: false,
                })
            }
        })
    }

    // 检查主题扩展状态
    checkThemeStatus = (url) => {
        window.open(url || '');
        this.setState({
            isShowRecheck: true,
        })
    }

    // 检测状态
    checkWebsiteState = async () => {
        let res = await reqCheckWebStatus();
        if (res.ack === 1) {
            this.setState({
                passwordStatus: res.data.is_password !== 0,
            })
        } else {
            this.props.toggleToast(res.msg, true);
        }
    }

    // 关闭免费试用横幅
    closeFreeTrialBanner = () => {
        this.setState({
            isShowTrualStatus: false,
        }, () => {
            try {
                sessionStorage.setItem("isShowTrualStatus", "close");
            } catch (e) { }
        })
    }

    // 打开免费试用弹窗
    openTrialModal = () => {
        const frChild = window.FrameBlock;
        if (frChild) {
            frChild.showTrialModal(2);
        }
    }

    // 探索更多功能tab
    handleExploreTabSelect = (selected) => {
        this.setState({
            ExploreFeaturesTab: selected,
        })
    }

    // 设置性能指标tab
    handleSetPerformanceTab = (tab) => {
        this.setState({
            performanceTab: tab,
        })
    }

    // 操作kp视频
    toggleKeywordPlannerVM = () => {
        this.setState({
            keywordPlannerVMState: !this.state.keywordPlannerVMState,
        })
    }

    // 操作kp视频
    toggleVideoModal = (video) => {
        this.setState({
            [video]: !this.state[video],
        })
    }

    // 操作404视频
    toggleBrokenLinkVM = () => {
        this.setState({
            brokenLinkVMState: !this.state.brokenLinkVMState,
        })
    }

    // 操作视频
    handleChangeVM = (column) => {
        switch (column) {
            case "Find Content Idea":
                this.toggleKeywordPlannerVM();
                break;
            case "Broken Link Redirects":
                this.toggleBrokenLinkVM();
                break;
        }
    }

    // 关闭AMP下架提示banner
    handleCloseAmpDownBanner = () => {
        this.setState({
            showAmpDownBanner: false
        }, () => {
            this.props.requestStateSet('amp_any_page_enabled', 1);
        })
    }

    componentWillUnmount() {
        this.clearAppArray();
        this.clearTimerArray();
        this.clearSpeedArray();
        timerArrPage.map(timer => {
            clearInterval(timer);
            timerArrPage.pop();
            return false;
        })

        timerArr.map(timer => {
            clearInterval(timer);
            timerArr.pop();
            return false;
        })
        this.setState = () => false;
    }

    render() {
        const {
            state: {
                journeyList,
                currentSelected,
                adverList,
                // isShowReviewbanner,
                // isBeforeShowBanner,
                // isStartInx,
                // isShowAffiliateBanner,
                isShowGuideBox,
                isShowFeedback,
                isShowGuideMain,
                // googleState,
                // isCurrentShow,
                isShowPageflyBanner,
                adverShowMore,
                isShowAdver,
                isCheckLoading,
                pageFlyState,
                AppAdverList,
                RecheckButtonLoading,
                level,
                importantIssues,
                needImprove,
                // goodResult,
                // scanTime,
                // isShowNewFunc,
                // newFuncList,
                // FBLoading,
                // isShowFuncNums,
                showTipModalStatus,
                themeAppExtensionUrl,
                isShowRecheck,
                // isShowTask,
                // passwordStatus,
                isShowTrialDiscount,
                isShowTrualStatus,
                trial_days,
                ExploreFeaturesTab,
                ExploreFeaturesData,
                performanceTab,
                isFinishGuide,
                myWebsiteScore,
                pcSpeedScore,
                mobileSpeedScore,
                refreshStatus,
                finishGuideObj,
                SEOScorePerc,
                userInfo,
                keywordPlannerVMState,
                brokenLinkVMState,
                webCheckVMState,
                SpeedOptVMState,
                showAmpDownBanner,
                StructuredDataVMState,

            },
            jumpTargetUrl,
            // setReview,
            // mouseEnterReview,
            // mouseLeaveReview,
            handleDismiss,
            changeGuideSet,
            handleGuideMain,
            openGuideItem,
            changeFinishState,

        } = this;

        // AMP 下架提示banner
        const ampDownBanner = showAmpDownBanner && <Banner
            title={t("AMP is being phased out")}
            onDismiss={this.handleCloseAmpDownBanner}
            secondaryAction={{
                content: t("Go to settings"),
                onAction: () => this.jumpToPage('/speedOpt/seo-ant-amp')
            }}
        >
            <p>{t("Google dropped AMP's ranking boost in 2021 — it no longer benefits SEO and may hold your site back. We recommend turning it off. Once turned off, existing AMP links will redirect to their standard pages, and this setting can't be re-enabled.")}</p>
        </Banner>

        // 404 视频弹窗
        const brokenLinkVM = <Modal title={t("Shopify 404 Errors - The ULTIMATE Fix Guide | Shopify SEO Made Easy Ep.3")}
            size="large"
            open={brokenLinkVMState}
            onClose={this.toggleBrokenLinkVM}>
            <div className={'youtube-video-box'}>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/8zuEbV0XzXQ?si=MVAlA5dhzgZGAm5T" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            </div>
        </Modal>

        // keyword planner 视频弹窗
        const keywordPlannerVM = <Modal title={t("From Keyword to Traffic: Build SEO Topical Clustering in Minutes-2025")}
            size="large"
            open={keywordPlannerVMState}
            onClose={this.toggleKeywordPlannerVM}>
            <div className={'youtube-video-box'}>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/FnDwS_IYi4E?si=CRzxxcFrEI97rzAr" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            </div>
        </Modal>

        // SEO Check 视频弹窗
        const WebCheckVM = <Modal title={t("Shopify SEO Made Easy | Shopify SEO Checker Reveals What's Hurting Your Rankings")}
            size="large"
            open={webCheckVMState}
            onClose={() => this.toggleVideoModal("webCheckVMState")}>
            <div className={'youtube-video-box'}>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/W4JL0hpZvag?si=5AfvsNuG0nr5b1vA" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            </div>
        </Modal>

        // 速度优化 视频弹窗
        const SpeedOptVM = <Modal title={t("Shopify SEO Made Easy: Shopify Speed for Beginners | Ep.2")}
            size="large"
            open={SpeedOptVMState}
            onClose={() => this.toggleVideoModal("SpeedOptVMState")}>
            <div className={'youtube-video-box'}>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/esikd7t5HZE?si=xs1bgNgq7i9T97mk" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            </div>
        </Modal>

        // 结构化数据 视频弹窗
        const StructuredDataVM = <Modal title={t("Shopify SEO Made Easy: Shopify Structured Data for Beginners | Ep.4")}
            size="large"
            open={StructuredDataVMState}
            onClose={() => this.toggleVideoModal("StructuredDataVMState")}>
            <div className={'youtube-video-box'}>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/tv5q7oTFd6Y?si=yq2_cNMWRseGlmiG" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
        </Modal>

        // 扩展banner
        const embedBanner = showTipModalStatus && <Banner
            tone="warning"
            title={t("Enable Shopify app embed")}
            onDismiss={() => {
                this.setState({ showTipModalStatus: false })
            }}
        >
            <BlockStack gap={200}>
                <p>{t("Some important functions require the SEOWILL extension to be installed before they can be used.")}</p>
                <div className='flex_layout'>
                    <Button onClick={() => this.checkThemeStatus(themeAppExtensionUrl)}>{t("Enable app embed")}</Button>
                    {
                        isShowRecheck && <Button variant='plain' onClick={() => this.checkThemeExtension(true, null)} loading={isCheckLoading}>{t("Recheck")}</Button>
                    }
                </div>
            </BlockStack>
        </Banner>

        // 免费试用横幅
        const freeTrialBanner = (isShowTrialDiscount && isShowTrualStatus && level === 1) && <div className='free-trial-banner' style={{ backgroundImage: "url('/imgs/banner/act_bg.png')" }}>
            <div className='free_trial_banner_content'>
                <div className='free_trial_banner_content_left'>
                    <h2 className='free_trial_banner_title'>{t("Stay Ahead in SEO Now — Get 50% Off!")}</h2>
                    <p className='free_trial_banner_desc'>{t("Boost your website traffic by 4.2x with SEOWILL Premium")}</p>
                    <button type='button' className='free_trial_banner_btn' onClick={this.openTrialModal}>
                        <span>{t("Try Free For {{v1}} Days", trial_days)}</span>
                        <span className='free_trial_banner_btn_icon'>
                            <Icon source={ArrowRightIcon} />
                        </span>
                    </button>
                </div>
                <div className='free_trial_banner_content_right'>
                    <img src='/imgs/banner/upto.png' alt='' />
                </div>
            </div>
            <button type='button' className='free_trial_banner_close' onClick={this.closeFreeTrialBanner} aria-label={t("Close")}>
                <Icon source={XIcon} tone='text-inverse' />
            </button>
        </div>

        // pageFly banner
        const reAppBanner = (isShowPageflyBanner && AppAdverList.length > 0 && !showTipModalStatus && !isCheckLoading) && <div className='pagefly_banner'>
            {
                AppAdverList.map((item, index) => {
                    return <div key={item.id} style={{ display: pageFlyState - 1 === index ? 'block' : 'none' }}>
                        <Banner
                            title={t(item.title)}
                            tone="info"
                            onDismiss={this.closePageflyBanner}
                        >
                            <p style={{ marginBottom: '0.3rem' }}>{t(item.desc)}</p>
                            <Button size='slim' onClick={() => this.jumpOutUrl(item)}>{t(item.btn)}</Button>
                        </Banner>
                    </div>
                })
            }
        </div>

        // 新手引导
        const cirIcon = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="_hUo3"><path fillRule="evenodd" clipRule="evenodd" d="M21.9147 13.3062L19.9315 13.0475C19.9761 12.7056 19.9993 12.3561 19.9993 12.0001C19.9993 11.6442 19.9761 11.2946 19.9315 10.9527L21.9147 10.694C21.9705 11.1215 21.9993 11.5575 21.9993 12.0001C21.9993 12.4428 21.9705 12.8787 21.9147 13.3062ZM21.2405 8.17224L19.393 8.93835C19.1238 8.28906 18.7709 7.68206 18.3474 7.13093L19.9333 5.91228C20.4621 6.6004 20.9033 7.35927 21.2405 8.17224ZM18.0871 4.06613L16.8685 5.65197C16.3173 5.22845 15.7103 4.87563 15.061 4.60638L15.8271 2.75893C16.6401 3.09605 17.399 3.53734 18.0871 4.06613ZM13.3054 2.08464L13.0467 4.06784C12.7048 4.02324 12.3552 4.00012 11.9993 4.00012C11.6433 4.00012 11.2938 4.02324 10.9519 4.06784L10.6932 2.08464C11.1206 2.02889 11.5566 2.00012 11.9993 2.00012C12.4419 2.00012 12.8779 2.02889 13.3054 2.08464ZM8.17139 2.75893L8.9375 4.60638C8.2882 4.87563 7.6812 5.22845 7.13008 5.65197L5.91143 4.06613C6.59954 3.53734 7.35841 3.09606 8.17139 2.75893ZM4.06527 5.91228L5.65111 7.13093C5.22759 7.68206 4.87478 8.28906 4.60552 8.93835L2.75807 8.17225C3.0952 7.35927 3.53648 6.6004 4.06527 5.91228ZM2.08379 10.694C2.02803 11.1215 1.99927 11.5575 1.99927 12.0001C1.99927 12.4428 2.02803 12.8787 2.08379 13.3062L4.06699 13.0475C4.02239 12.7056 3.99927 12.3561 3.99927 12.0001C3.99927 11.6442 4.02239 11.2946 4.06699 10.9527L2.08379 10.694ZM2.75807 15.828L4.60553 15.0619C4.87478 15.7112 5.22759 16.3182 5.65111 16.8693L4.06527 18.088C3.53648 17.3998 3.0952 16.641 2.75807 15.828ZM5.91143 19.9341L7.13008 18.3483C7.68121 18.7718 8.28821 19.1246 8.9375 19.3939L8.17139 21.2413C7.35841 20.9042 6.59955 20.4629 5.91143 19.9341ZM10.6932 21.9156L10.9519 19.9324C11.2938 19.977 11.6433 20.0001 11.9993 20.0001C12.3552 20.0001 12.7048 19.977 13.0467 19.9324L13.3054 21.9156C12.8779 21.9714 12.4419 22.0001 11.9993 22.0001C11.5566 22.0001 11.1206 21.9714 10.6932 21.9156ZM15.8271 21.2413L15.061 19.3939C15.7103 19.1246 16.3173 18.7718 16.8685 18.3483L18.0871 19.9341C17.399 20.4629 16.6401 20.9042 15.8271 21.2413ZM19.9333 18.088L18.3474 16.8693C18.7709 16.3182 19.1238 15.7112 19.393 15.0619L21.2405 15.828C20.9033 16.641 20.4621 17.3998 19.9333 18.088Z" fill="#8C9196" className="Pklnb WzwlI"></path><path fillRule="evenodd" clipRule="evenodd" d="M10.5334 2.10692C11.0126 2.03643 11.5024 2 12 2C12.4976 2 12.9874 2.03643 13.4666 2.10692C14.013 2.18729 14.3908 2.6954 14.3104 3.2418C14.23 3.78821 13.7219 4.166 13.1755 4.08563C12.7924 4.02927 12.3999 4 12 4C11.6001 4 11.2076 4.02927 10.8245 4.08563C10.2781 4.166 9.76995 3.78821 9.68958 3.2418C9.6092 2.6954 9.987 2.18729 10.5334 2.10692ZM7.44122 4.17428C7.77056 4.61763 7.67814 5.24401 7.23479 5.57335C6.603 6.04267 6.04267 6.603 5.57335 7.23479C5.24401 7.67814 4.61763 7.77056 4.17428 7.44122C3.73094 7.11188 3.63852 6.4855 3.96785 6.04216C4.55386 5.25329 5.25329 4.55386 6.04216 3.96785C6.4855 3.63852 7.11188 3.73094 7.44122 4.17428ZM16.5588 4.17428C16.8881 3.73094 17.5145 3.63852 17.9578 3.96785C18.7467 4.55386 19.4461 5.25329 20.0321 6.04216C20.3615 6.4855 20.2691 7.11188 19.8257 7.44122C19.3824 7.77056 18.756 7.67814 18.4267 7.23479C17.9573 6.603 17.397 6.04267 16.7652 5.57335C16.3219 5.24401 16.2294 4.61763 16.5588 4.17428ZM3.2418 9.68958C3.78821 9.76995 4.166 10.2781 4.08563 10.8245C4.02927 11.2076 4 11.6001 4 12C4 12.3999 4.02927 12.7924 4.08563 13.1755C4.166 13.7219 3.78821 14.23 3.2418 14.3104C2.6954 14.3908 2.18729 14.013 2.10692 13.4666C2.03643 12.9874 2 12.4976 2 12C2 11.5024 2.03643 11.0126 2.10692 10.5334C2.18729 9.987 2.6954 9.6092 3.2418 9.68958ZM20.7582 9.68958C21.3046 9.6092 21.8127 9.987 21.8931 10.5334C21.9636 11.0126 22 11.5024 22 12C22 12.4976 21.9636 12.9874 21.8931 13.4666C21.8127 14.013 21.3046 14.3908 20.7582 14.3104C20.2118 14.23 19.834 13.7219 19.9144 13.1755C19.9707 12.7924 20 12.3999 20 12C20 11.6001 19.9707 11.2076 19.9144 10.8245C19.834 10.2781 20.2118 9.76995 20.7582 9.68958ZM4.17428 16.5588C4.61763 16.2294 5.24401 16.3219 5.57335 16.7652C6.04267 17.397 6.603 17.9573 7.23479 18.4267C7.67814 18.756 7.77056 19.3824 7.44122 19.8257C7.11188 20.2691 6.4855 20.3615 6.04216 20.0321C5.25329 19.4461 4.55386 18.7467 3.96785 17.9578C3.63852 17.5145 3.73094 16.8881 4.17428 16.5588ZM19.8257 16.5588C20.2691 16.8881 20.3615 17.5145 20.0321 17.9578C19.4461 18.7467 18.7467 19.4461 17.9578 20.0321C17.5145 20.3615 16.8881 20.2691 16.5588 19.8257C16.2294 19.3824 16.3219 18.756 16.7652 18.4267C17.397 17.9573 17.9573 17.397 18.4267 16.7652C18.756 16.3219 19.3824 16.2294 19.8257 16.5588ZM9.68958 20.7582C9.76995 20.2118 10.2781 19.834 10.8245 19.9144C11.2076 19.9707 11.6001 20 12 20C12.3999 20 12.7924 19.9707 13.1755 19.9144C13.7219 19.834 14.23 20.2118 14.3104 20.7582C14.3908 21.3046 14.013 21.8127 13.4666 21.8931C12.9874 21.9636 12.4976 22 12 22C11.5024 22 11.0126 21.9636 10.5334 21.8931C9.987 21.8127 9.6092 21.3046 9.68958 20.7582Z" fill="#8A8A8A" className="CLJ7G WzwlI"></path><circle cx="12" cy="12" r="12" fill="#DBDDDF" className="Pklnb hKH6r"></circle><circle cx="12" cy="12" r="9" fill="#F6F6F7" stroke="#999EA4" strokeWidth="2" className="hKH6r"></circle></svg>;
        const finishIcon = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="DdVKM"><circle cx="12" cy="12" r="10" fill="#000"></circle><path d="M17.2738 8.52629C17.6643 8.91682 17.6643 9.54998 17.2738 9.94051L11.4405 15.7738C11.05 16.1644 10.4168 16.1644 10.0263 15.7738L7.3596 13.1072C6.96908 12.7166 6.96908 12.0835 7.3596 11.693C7.75013 11.3024 8.38329 11.3024 8.77382 11.693L10.7334 13.6525L15.8596 8.52629C16.2501 8.13577 16.8833 8.13577 17.2738 8.52629Z" fill="#fff"></path></svg>
        const comp = Object.keys(journeyList).filter(i => Boolean(journeyList[i]['status'])).length;
        const allp = Object.keys(journeyList).length;
        const UserGuide = isShowGuideBox ? <Card>
            <BlockStack gap={200}>
                <div className='guide_top'>
                    {
                        isFinishGuide ? <div className='guide_finish'>
                            {
                                !['Netherlands', 'Canada', 'Italy', 'New Zealand', 'South Africa'].includes(userInfo?.country) ? <>
                                    <Text variant="headingMd" as="h2">🎉&nbsp;&nbsp;{t("Your store is SEO-ready! Love SEOWILL? Leave a quick review")}&nbsp;&nbsp;⭐️</Text>
                                    {/* <div className="start_review">
                                        {[1, 2, 3, 4, 5].map((num) => (
                                            <div
                                                key={num}
                                                className={`start_review_item ${isStartInx >= num ? 'isReviewHigh' : ''}`}
                                                onMouseEnter={() => mouseEnterReview(num)}
                                                onMouseLeave={() => mouseLeaveReview(num)}
                                                onClick={() => setReview(num)}
                                            >
                                                <Icon source={StarIcon} />
                                            </div>
                                        ))}
                                    </div> */}
                                    <StarRating onRate={this.handleRateSet} />
                                </> : <>
                                    <Text variant="headingMd" as="h2">🎉&nbsp;&nbsp;{t("Your store is SEO-ready!")}</Text>
                                </>
                            }
                        </div> : <Text variant="headingMd" as="h2">{t("Let's get your website SEO-ready in {{v1}} quick steps", 4)}</Text>
                    }
                    <div className='guide_opera'>
                        <Popover
                            active={isShowFeedback}
                            activator={<div>
                                <Button variant='tertiary' icon={MenuHorizontalIcon} tone='base' onClick={changeGuideSet}></Button>
                            </div>}
                            onClose={changeGuideSet}
                        >
                            <ActionList
                                actionRole="menuitem"
                                items={[
                                    {
                                        content: t("Dismiss"),
                                        onAction: () => handleDismiss(SwitchAll['0']),
                                        icon: XIcon
                                    },
                                    // {
                                    //     content: t("Give feedback"),
                                    //     onAction: openGiveFeedbackBox,
                                    //     icon: ChatMajor
                                    // },
                                ]}
                            />
                        </Popover>
                        <div>
                            <Button variant='tertiary' icon={isShowGuideMain ? ChevronUpIcon : ChevronDownIcon} tone='base' onClick={handleGuideMain}></Button>
                        </div>
                    </div>
                </div>
                {
                    !isFinishGuide ? <>
                        <div className='guide_progress'>
                            <Text as="p" color="subdued">{t("{{v1}} of {{v2}} tasks completed", comp, allp)}</Text>
                            <ProgressBar tone='primary' progress={(100 / allp) * comp} size="small" />
                        </div>
                    </> : null
                }
            </BlockStack>
            <Collapsible
                id={`guide-main-collapsible`}
                open={isShowGuideMain}
                transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
                expandOnPrint
            >
                <div className='guide_content'>
                    <Layout>
                        <Layout.Section>
                            {
                                Object.keys(journeyList).map(item => {
                                    return <div key={item} onClick={() => openGuideItem(journeyList[item]['id'])} className={`gItem ${currentSelected === journeyList[item]['id'] ? 'gActive' : ''}`}>
                                        {
                                            finishGuideObj === item ? <div className='circle_point circle_point_loading'>
                                                <Spinner size='small' />
                                            </div> : <div className='circle_point' onClick={(e) => changeFinishState(e, item, journeyList[item])}>
                                                {!Boolean(journeyList[item]?.status) ? cirIcon : finishIcon}
                                            </div>
                                        }
                                        <div className='guide_middle_content'>
                                            <BlockStack gap={200}>
                                                <div className='gItem_title'>
                                                    {
                                                        currentSelected === journeyList[item].id ?
                                                            <Text variant="headingMd" as="h6">{t(journeyList[item].tag)}</Text> :
                                                            <Text as="p" fontWeight="regular">{t(journeyList[item].tag)}</Text>
                                                    }
                                                </div>
                                                <Collapsible
                                                    open={currentSelected === journeyList[item].id}
                                                    id={`${item}-collapsible`}
                                                    transition={{ duration: '300ms', timingFunction: 'var(--p-motion-ease-in-out)' }}
                                                    expandOnPrint
                                                >
                                                    <div className='guide_col_main flex_layout'>
                                                        <div className='gItemContent'>
                                                            <BlockStack gap={400}>
                                                                <Text as="p" color="subdued">{t(journeyList[item].desc)}</Text>
                                                                {
                                                                    journeyList[item].title !== "EmBed" ?
                                                                        <div><Button onClick={() => this.jumpToPage(journeyList[item].url, 'tip')} variant='primary' size='slim'>{t(journeyList[item].btn)}</Button></div>
                                                                        :
                                                                        <div>
                                                                            <Button onClick={() => {
                                                                                window.open(journeyList[item].url)
                                                                            }} variant='primary' size='slim'>{t(journeyList[item].btn)}</Button>
                                                                            &nbsp;&nbsp;&nbsp;
                                                                            {!Boolean(journeyList[item].status) ? <Button variant='plain' loading={isCheckLoading} onClick={() => this.checkThemeExtension(true, null)}>{t("Recheck")}</Button> : null}
                                                                        </div>
                                                                }
                                                            </BlockStack>
                                                        </div>
                                                    </div>
                                                </Collapsible>
                                            </BlockStack>
                                        </div>
                                        <div className={`guide_img ${currentSelected === journeyList[item].id ? 'guide_show_img' : ''}`}><img src={`${journeyList[item].img}?v=12305`} alt='' /></div>
                                    </div>
                                })
                            }
                        </Layout.Section>
                    </Layout>
                </div>
            </Collapsible>
        </Card> : null;

        // 仪表盘卡片
        const DashboardCards = <Card padding={0}>
            <div className='home_panel'>
                <div className='SEOCheck_panel home_panel_item'>
                    <Text variant="headingSm" as="h3" fontWeight="semibold">{t("SEO Health Score")}</Text>
                    <div className='SEOCheck_panel_content'>
                        <div className='SEOCheck_panel_content_gauge'>
                            <CircularGauge score={myWebsiteScore} />
                            <div className='SEOCheck_panel_content_gauge_score'>
                                <Text variant="heading2xl" as="h2">
                                    <span style={{ color: myWebsiteScore <= 60 ? '#D33430' : myWebsiteScore > 60 && myWebsiteScore <= 85 ? '#F1930F' : '#27AE60' }}>{myWebsiteScore}</span>
                                </Text>
                                <Text variant="bodyMd" as="p" fontWeight="medium">
                                    <span className='score_percent'>
                                        {
                                            (Number(SEOScorePerc) !== 0) ? <>
                                                <span style={{ transform: SEOScorePerc > 0 ? '' : 'rotate(90deg)' }}>
                                                    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M2.58383 8.41608C2.398 8.23025 2.398 7.92896 2.58383 7.74313L6.93088 3.39608L4.49053 3.3962C4.22773 3.39622 4.01468 3.18318 4.01466 2.92038C4.01465 2.65758 4.22768 2.44453 4.49048 2.44452L8.0797 2.44434C8.20591 2.44433 8.32695 2.49446 8.4162 2.58371C8.50544 2.67295 8.55558 2.79399 8.55557 2.9202L8.55539 6.50942C8.55538 6.77222 8.34232 6.98526 8.07952 6.98524C7.81672 6.98523 7.60369 6.77218 7.6037 6.50937L7.60382 4.06903L3.25677 8.41608C3.07095 8.6019 2.76966 8.6019 2.58383 8.41608Z" fill={SEOScorePerc > 0 ? "#29CC6A" : "#cd2e2a"} />
                                                    </svg>
                                                </span>
                                                <span style={{ color: SEOScorePerc > 0 ? "#29CC6A" : "#cd2e2a" }}>{SEOScorePerc}%</span>
                                            </> : <span style={{ opacity: 0 }}>-</span>
                                        }
                                    </span>
                                </Text>
                            </div>
                        </div>
                        <Text variant="bodyMd" as="p" fontWeight="medium">{t("We found")} <span style={{ color: '#D33430' }}>{refreshStatus ? "-" : (importantIssues + needImprove)}</span> {t("issues affecting your rankings.")}</Text>
                        <div><Button onClick={() => this.jumpToPage('/website-check')}>{t("Fix Now")}</Button></div>
                    </div>
                </div>
                <div className='SpeedUp_panel home_panel_item'>
                    <div className='score_performance_top'>
                        <div><Text variant="headingSm" as="h3" fontWeight="semibold">{t("PageSpeed Score")}</Text></div>
                        <div className='performance_tab'>
                            <div onClick={() => this.handleSetPerformanceTab('pc')} className={`performance_tab_pc ${performanceTab === 'pc' ? 'active' : ''}`}><Icon source={DesktopIcon} tone='base' /></div>
                            <div onClick={() => this.handleSetPerformanceTab('mb')} className={`performance_tab_mb ${performanceTab === 'mb' ? 'active' : ''}`}><Icon source={MobileIcon} tone='base' /></div>
                        </div>
                    </div>
                    <div className='SpeedUp_panel_content'>
                        <InstrumentPanel
                            isPwd={true}
                            isSpeed={true}
                            speedType={performanceTab}
                            svgHeight={120}
                            strokeDash={performanceTab === 'pc' ? pcSpeedScore : mobileSpeedScore}
                            strokeWidth={12}
                            smallSize={0.3}
                            loading={RecheckButtonLoading}
                            isShowRecheck={false}
                            onRecheck={() => { }}
                        />
                        <Text variant="bodyMd" as="p" fontWeight="medium">
                            {t("Speed Up Level")}: &nbsp;
                            <span style={{ color: 'var(--color-primary)' }}>
                                {level === 3 ? t("Turbo") : level === 2 ? t("Rocket") : t("Basic")}
                            </span>
                        </Text>
                        <Button onClick={() => this.jumpToPage('/speedOpt/site-speedup')}>{t("Speed Up")}</Button>
                    </div>
                </div>
            </div>
        </Card>

        // 探索更多功能
        const ExploreMoreFeatures = <Card padding={0}>
            <div className="explore-more-features">
                {/* 标签按钮区域 */}
                <div className="explore-more-features-tabs">
                    <Tabs
                        selected={ExploreFeaturesTab}
                        tabs={[
                            {
                                id: 'create',
                                content: t("Create New Content"),
                            },
                            {
                                id: 'optimize',
                                content: t("Optimize Existing Content"),
                            },
                            {
                                id: 'boost',
                                content: t("Boost Site Performance"),
                            },
                            {
                                id: 'aiVisibility',
                                content: t("Boost AI Visibility"),
                            },
                        ]}
                        onSelect={this.handleExploreTabSelect}
                    />
                </div>

                {/* 内容区域 */}
                <div className="explore-more-features-content">
                    {
                        Object.keys(ExploreFeaturesData).map((item, index) => {
                            const _row = ExploreFeaturesData[item]?.RowItem || {};
                            const _column = ExploreFeaturesData[item]?.ColumnItem || {};
                            return <div key={`${item}-${index}`} className='e_m_item' style={{ display: ExploreFeaturesTab === index ? 'block' : 'none' }}>
                                <BlockStack gap={400}>
                                    {
                                        Object.keys(_row).length > 0 ? Object.keys(_row).map((row, index) => {
                                            return <div key={`${row}-${index}-row`} className='e_m_row e_m_child'>
                                                <div className='e_m_row_content'>
                                                    <Text variant="headingMd" as="h2" fontWeight='semibold'>{t(row)}</Text>
                                                    <Text variant="bodyMd" as="p" tone='subdued'>{t(_row[row].desc)}</Text>
                                                    <Button onClick={() => this.jumpToPage(_row[row].url)}>{t("Explore now")}</Button>
                                                </div>
                                                <div className={`${_row[row]?.video ? 'e_m_row_img_video' : 'e_m_row_img'}`}>
                                                    {
                                                        _row[row]?.video ? <VideoThumbnail
                                                            videoLength={_row[row].time}
                                                            thumbnailUrl={_row[row].img}
                                                            onClick={() => this.toggleVideoModal(_row[row].video)}
                                                        /> : <img src={_row[row].img} alt={row} />
                                                    }
                                                </div>
                                            </div>
                                        }) : null
                                    }
                                    <div className='e_m_column_box'>
                                        {
                                            Object.keys(_column).length > 0 ? Object.keys(_column).map((column, index) => {
                                                return <div key={`${column}-${index}-column`} className='e_m_column e_m_child' onClick={() => this.jumpToPage(_column[column].url)}>
                                                    <span>{_column[column].svg}</span>
                                                    <div>
                                                        <Text variant="headingMd" as="h2" fontWeight='semibold'>{t(column)}</Text>
                                                        <Text variant="bodyMd" as="p" tone='subdued'>
                                                            {t(_column[column].desc)}&nbsp;
                                                            {
                                                                column === "Find Content Idea" || column === "Broken Link Redirects" ? <Button variant='plain' onClick={(e) => {
                                                                    e && e.stopPropagation();
                                                                    this.handleChangeVM(column);
                                                                }}>{t("Watch tutorial")}</Button> : null
                                                            }
                                                        </Text>
                                                    </div>
                                                </div>
                                            }) : null
                                        }
                                    </div>
                                </BlockStack>
                            </div>
                        })
                    }
                </div>
            </div>
        </Card>

        // 广告模块
        const adverBox = (adverList.length > 0 && isShowAdver) && <div className='adverBox'>
            <Card>
                <div className='adver_box_title'>
                    <Text variant="headingMd" as="h2">{t("Recommended Apps")}</Text>
                    <div className='flex_layout' style={{ columnGap: '1.2em' }}>
                        <Button icon={ViewIcon} variant='plain' onClick={() => this.jumpAppRecommand()}>{t("View more")}</Button>
                        <Popover
                            active={adverShowMore}
                            activator={
                                <div style={{ display: 'flex' }}>
                                    <Button variant='tertiary' icon={MenuHorizontalIcon} onClick={() => {
                                        this.setState({
                                            adverShowMore: !adverShowMore
                                        })
                                    }}></Button>
                                </div>
                            }
                            autofocusTarget="first-node"
                            onClose={() => {
                                this.setState({
                                    adverShowMore: false
                                })
                            }}
                        >
                            <ActionList
                                actionRole="menuitem"
                                items={[
                                    {
                                        content: t("Dismiss"),
                                        icon: XIcon,
                                        onAction: this.closeAdverBox
                                    }
                                ]}
                            />
                        </Popover>
                    </div>
                </div>
                <div className='adver_swiperbox' onMouseLeave={() => { }}>
                    <Swiper
                        slidesPerView={"auto"}
                        loop={adverList.length > 1 ? true : false}
                        autoplay={{
                            delay: 5000,
                            disableOnInteraction: false
                        }}
                        modules={[Autoplay, Pagination, Navigation]}
                        pagination={{
                            clickable: true,
                        }}
                        touchRatio={0.5}
                        spaceBetween={10}
                        initialSlide={0}
                    >
                        {adverList.map((item, index) => {
                            return <SwiperSlide key={index}>
                                {Boolean(item.img_url) ? <img className='show_adver_img' src={item.img_url} alt={item.id} onClick={() => jumpTargetUrl(item.id, item.jump_url, item?.app_name || '')} /> : <div className='halfspace'></div>}
                                <div className='adver_app_list' style={{ marginBottom: adverList.length > 1 ? '1.5rem' : '0' }}>
                                    {
                                        (Boolean(item.list) && item.list.length > 0) && item.list.map((app, inx) => {
                                            return <div
                                                key={inx}
                                                className='app_main'
                                                // 曝光事件名
                                                data-cwill-report-name="recommend_app_exposure"
                                                // 曝光事件属性
                                                data-cwill-report-attr={JSON.stringify({
                                                    position: "home_recommended_apps",
                                                    recommend_app_id: `${app.id}`,
                                                    recommend_app_name: app.app_name,
                                                })}
                                                onClick={() => jumpTargetUrl(app.id, app.jump_url, app.app_name)}
                                            >
                                                <div className='app_img_block'><img className='app_img' src={app.img_url} alt={app.id} /></div>
                                                <div className='app_adver_info'>
                                                    <BlockStack gap={0}>
                                                        <div className='flex_layout' style={{ gap: '4px' }}>
                                                            <Text as="p" fontWeight="semibold">{app.app_name}</Text>
                                                            <span className='flex_layout'>
                                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M11.75 3.5C11.3358 3.5 11 3.83579 11 4.25C11 4.66421 11.3358 5 11.75 5H13.9393L8.96967 9.96967C8.67678 10.2626 8.67678 10.7374 8.96967 11.0303C9.26256 11.3232 9.73744 11.3232 10.0303 11.0303L15 6.06066V8.25C15 8.66421 15.3358 9 15.75 9C16.1642 9 16.5 8.66421 16.5 8.25V4.25C16.5 3.83579 16.1642 3.5 15.75 3.5H11.75Z" fill="#005BD3" />
                                                                    <path d="M15 10.9674C15 10.5532 14.6642 10.2174 14.25 10.2174C13.8358 10.2174 13.5 10.5532 13.5 10.9674V13.75C13.5 14.4404 12.9404 15 12.25 15H6.25C5.55964 15 5 14.4404 5 13.75L5 7.75C5 7.05964 5.55965 6.5 6.25 6.5L9.03261 6.5C9.44682 6.5 9.78261 6.16421 9.78261 5.75C9.78261 5.33579 9.44682 5 9.03261 5L6.25 5C4.73122 5 3.5 6.23122 3.5 7.75V13.75C3.5 15.2688 4.73122 16.5 6.25 16.5H12.25C13.7688 16.5 15 15.2688 15 13.75V10.9674Z" fill="#005BD3" />
                                                                </svg>
                                                            </span>
                                                        </div>
                                                        <div className='ellipsis_2'>
                                                            <Text as="p" tone="subdued">{app.desc}</Text>
                                                        </div>
                                                    </BlockStack>
                                                </div>
                                            </div>
                                        })
                                    }
                                </div>
                            </SwiperSlide>
                        })}
                    </Swiper>
                </div>
            </Card>
        </div>

        // 底部
        const FooterHelpBox = <FooterTrustHelp />

        // 最终页面
        const pageEndContent = <div className='DashboardContent'>
            {!this.state.dashboardData.status ? <SkeltonLoading /> : <Page
                title={<div className='home_title'>
                    {t("Welcome to SEOWILL")} {t("by")} <span onClick={this.goSolutionExpert}>CWILL</span>
                </div>}
            >
                <title>SEOWILL - Dashboard</title>

                {/* 新功能 | 任务福利 */}
                <div className='home_top_task'>
                    {/* 新功能 */}
                    {/* {newFunctions} */}
                    {/* 任务福利 */}
                    {/* {taskFunctions} */}
                    {/* App扩展状态 */}
                    <Button onClick={() => this.checkThemeStatus(themeAppExtensionUrl)}>
                        <div className="theme_state_top flex_layout">
                            <span className={`theme_dot ${!Boolean(showTipModalStatus) ? 'active-dot' : 'disable-dot'}`}></span>
                            <span>{!Boolean(showTipModalStatus) ? t("App embed enabled") : t("App embed disabled")}</span>
                        </div>
                    </Button>
                </div>

                {/* 内容区域 */}
                <BlockStack gap={400}>
                    {/* AMP 下架提示banner */}
                    {ampDownBanner}
                    {/* Banner模块 */}
                    {embedBanner}
                    {reAppBanner}
                    {/* 新手引导 */}
                    {UserGuide}
                    {/* 免费试用横幅 */}
                    {freeTrialBanner}

                    {/* 页面主内容 */}
                    <div className="page_main_content">
                        <BlockStack gap={400}>
                            {/* 仪表盘卡片 */}
                            {DashboardCards}
                            {/* 探索更多功能 */}
                            {ExploreMoreFeatures}
                            {/* 广告列表 */}
                            {adverBox}
                        </BlockStack>
                    </div>
                </BlockStack>

                {keywordPlannerVM}
                {WebCheckVM}
                {SpeedOptVM}
                {brokenLinkVM}
                {StructuredDataVM}
                {/* 底部 */}
                {FooterHelpBox}
            </Page>}
        </div>

        return pageEndContent;
    }
}

const mapStateToProps = state => {
    return state
}

const mapDispatchToProps = dispatch => ({
    // 设置评价状态
    setStartReview(states) {
        dispatch(saveStartReview(states))
    },

    // 判断是否页面第一次loading
    getPageDataRedux(data) {
        dispatch(setPageData(['speedAnalysis', data]));
    },

    // 设置支付回调提示状态
    setPayTipState(data) {
        dispatch(savePayTip(data));
    },

})

dashboardClass = connect(
    mapStateToProps,
    mapDispatchToProps
)(dashboardClass);

export default withRouter(dashboardClass);